import { Component, ElementRef, Input, OnInit, ViewChild, ChangeDetectorRef, TemplateRef } from '@angular/core';
import { EmailAssessment } from 'src/app/core/services/emailassessment.service';
import { ActivatedRoute } from '@angular/router';
import { AbstractControl, UntypedFormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, Validators, FormControl } from '@angular/forms';
import { ConfirmationDialogComponent } from 'src/app/common/confirmation-dialog/confirmation-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { validationMessage } from 'src/app/core/validationMessage/validationMessage';
import { CookieService } from 'ngx-cookie-service';
import { ConfirmSaveComponent } from 'src/app/common/confirm-save/confirm-save.component';
import * as moment from 'moment';
import { localStorageConstants,assesmentFileTypes, localStorageVariables } from 'src/app/core/localStorageConstants/localStorageConstants';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { QuestionnaireService } from 'src/app/core/services/questionnaire.service';
import { CategoryEssentialsService } from 'src/app/components/people-details/people-questionnaire-category/category-essentials.service';
import { SkipLogicService } from 'src/app/core/services/skip-logic.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationSuccessEmailComponent } from 'src/app/common/confirmation-success-email/confirmation-success-email.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { InteractorService } from 'src/app/core/services/interactor.service';
import { LookupService } from 'src/app/core/services/lookup.service';
import { CustomScoringService } from 'src/app/core/services/custom-scoring.service';
import { QuestionnaireInteractionService } from 'src/app/core/services/questionnaire-interaction.service';
import { AssessmentService } from 'src/app/core/services/assessment.service';
import { ConfirmDiscardComponent } from 'src/app/common/confirm-discard/confirm-discard.component';
import { CommonService } from 'src/app/shared/services/common.service';
import { ValidateWhiteSpace } from 'src/app/core/validators/whiteSpace.validator';

@Component({
  selector: 'app-email-assessment',
  templateUrl: './email-assessment.component.html',
  styleUrls: ['./email-assessment.component.scss'],
})
export class EmailAssessmentComponent implements OnInit {
  modalRef: BsModalRef;
  @ViewChild('template') elementView: TemplateRef<any>;
  @ViewChild('noteInput') noteInput: ElementRef;
  @ViewChild('noteEditInput') noteEditInput: ElementRef;
  public isAuth: any = false;
  public alertMessage = validationMessage;
  // PCIS-10708: Email validation regex (matches pattern used in agency/helper/people forms)
  private emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  public emailassessmentData: any;
  public language: any = 'en';
  public previousLanguage: any = null;
  public isChanged: boolean=false;
  public modalTriggerFrom = null;
  public agencyLanguageId : any;
  languages: any;
  @ViewChild(ConfirmationSuccessEmailComponent)
  confirmationSuccessEmailComponent: ConfirmationSuccessEmailComponent;
  questionsAndDetails: any;
  categories: any;
  questionForm: UntypedFormGroup;
  public personSupportID;
  public currentSupportData;
  public titleFilterCtrl: UntypedFormControl = new UntypedFormControl();
  public otpVerification: UntypedFormGroup;
  currentQuestionIndex: any;
  currentCategoryIndex: any;
  personSupports: any;
  noOfCareGiversAdded = 1;
  isRequestSubmitted = false;
  isRequestInvalid = false;
  invalidStatusCode:number = 0;
  responseValueType = null;
  public today = new Date();
  public SummationArray: any = [];
  public percentages: any;
  public progressBarColor: any;
  public attendquestioncount: any = [];
  public versionitemdatacount: any = [];
  public totalquestioncount: any;
  public totalActiveSupports = 0;
  public constants = localStorageConstants;
  public shouldApplyMask =false;
  public currentDate = new Date();
  public fullAddressList:any =[]
  errorMessage = '';
  modalEvent: any;
  conformMessage: any;
  isFormValid = true;
  saveConformMessage: any;
  resetBtnDisable = false;
  toggleExpansionFlag = false;
  expandmessage = 'Expand All';
  finalAssessmentData: any;
  decryptId: any;
  scoringRules: any;
  scoreResponse: any;
  scoreResponseList: any;
  requiredConfidentialityLanguage: any;
  otherConfidentialityLanguage: any;
  personRequestedConfidentialityLanguage: any;
  @ViewChild(ConfirmationDialogComponent)
  confirmDialog: ConfirmationDialogComponent;
  @ViewChild(ConfirmSaveComponent) confirmSaveDialog: ConfirmSaveComponent;
  @ViewChild(ConfirmDiscardComponent) confirmDiscard: ConfirmDiscardComponent;
  skipRules: any;
  skipActions: any;
  hasSkipLogic: boolean;
  modalResponse: string;
  message: string;
  btnText: string;
  notesMandatoryQuestions: any;
  header: string;
  public Msg: any;
  public toggleClicked = false;
  public skippedQuestionsCount = 0;
  responseSliderType = null;
  responseListType = null;
  responseTextType = null;
  responseTextAreaType = null;
  responseDateType = null;
  responseCheckboxType = null;
  responseSignatureType = 8;
  responseDoodleType = 7
  signatureImage = null;
  signatureArray = [];
  fileToUpload: File | null = null;
  showResponse = true;
  inCompleteItemsArray = [];
  responseAttachmentType = 9;
  responseDocuSignType = 12;
  scoreResponseType: any;
  scoreResponseListType: any;
  brandingDetails = JSON.parse(localStorage.getItem('branding'));
  notification1 = this.brandingDetails?.branding?.BackgroundColors?.Notification1;
  redBorder = this.brandingDetails?.branding?.BackgroundColors?.RequiredAsterisk;
  semiBoldFont = this.brandingDetails?.branding?.Font?.SemiBoldFont;
  boldFont = this.brandingDetails?.branding?.Font?.BoldFont;
  regularFont = this.brandingDetails?.branding?.Font?.RegularFont;
  badgeColor = this.brandingDetails?.branding?.BackgroundColors?.Badge;
  overlayColor = this.brandingDetails?.branding?.BackgroundColors?.Overlay;
  fontFamily = this.brandingDetails?.branding?.BackgroundColors?.InsertColor;
  whiteColor = this.brandingDetails?.branding?.BackgroundColors?.WhitePaginationBackground;
  lightgrayColor = this.brandingDetails?.branding?.BackgroundColors?.DisabledHeaderBackground;
  afterSave = this.brandingDetails?.branding?.BackgroundColors?.GridBorder;
  approveReject = this.brandingDetails?.branding?.BackgroundColors?.BtnLogoContainer;
  disableColor = this.brandingDetails?.branding?.BackgroundColors?.DisabledBackground;
  blackColor = this.brandingDetails?.branding?.BackgroundColors?.NotesExpandButtonHover;
  headerColor = this.brandingDetails?.branding?.BackgroundColors.Headers;
  fileColor = this.brandingDetails?.branding?.BackgroundColors?.FileInput;
  styleColor = this.brandingDetails?.branding?.BackgroundColors.StyledBorderBottom;
  alternateRows = this.brandingDetails?.branding?.BackgroundColors.AlternateRows;
  infoIconColor = this.brandingDetails?.branding?.BackgroundColors.Notification1;
  headerFontColor = this.brandingDetails?.branding?.BackgroundColors?.HeaderFontColor;
  questionnaireCardBackground = this.brandingDetails?.branding?.BackgroundColors?.QuestionnaireCardBackground;
  questionnaireCardTableBackground = this.brandingDetails?.branding?.BackgroundColors?.QuestionnaireCardTableBackground;
  matWhite = this.brandingDetails?.branding?.MatColors?.MatWhite;
  button2 = this.brandingDetails?.branding.BackgroundColors?.Button2;
  confirmDeleteBtn = this.brandingDetails?.branding.BackgroundColors?.ConfirmDeleteBtn;
  confirmCancelBtn = this.brandingDetails?.branding.BackgroundColors?.ConfirmCancelBtn;
  ConfirmDeleteBtnHover = this.brandingDetails?.branding.BackgroundColors?.ConfirmDeleteBtnHover;
  buttonFont: any;
  isEnabledasterisk:any;
  responseCustomListType: any;
  public isMagellan = false;
  public childValuesForChange:any;
  @Input() public personIndex: any;
  public assessmentId: any;
  assessmentReason = '';
  otpText: string;
  matTealDark: any;
  greyLightBg: any;
  redBtn: string;
  greenBtn: string;
  linkButtons: string;
  headerBackground: string;
  tableHeadColor: string;
  public titles = [];
  public originaltitles: any = [];
  btnLightBlue: string;
  public questionCategoryArray: any = [];
  currentRole: any;
  isExternalUser: boolean = false;
  isFromAdvancedSearch: boolean = false;
  agencyID :any;
  isConsent: boolean = false;
  assessmentConfig: any=assesmentFileTypes;
  assessmentIDfromUrl: any;
  assesmentNumber: any;
  errorMessageList: any;
  userName: string;
  childItemCount: any = [];
  ischildItemSelected: boolean = false;
  instrumentID: any;
  enableResendLink:boolean = false
  enableHighlight: boolean = true;
  public confirmChildValueDiscardMessage = localStorageConstants.confirmChildValueDiscardMessage;
  public confirmBtnLabel = 'OK';
  public confirmCancelBtnLabel = 'Cancel';
  inviteToCompleteHtmlContent: any=null;

  constructor(
    public emailAssessment: EmailAssessment,
    private qiService: QuestionnaireInteractionService,
    private route: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private localStorageService: LocalStorageService,
    private questionnaireService: QuestionnaireService,
    private SkipLogicService: SkipLogicService,
    private modalService: BsModalService,
    private translatorService: TranslateService,
    public essentialsService: CategoryEssentialsService,
    private sanitizer: DomSanitizer,
    private qService: QuestionnaireService,
    private interactorService: InteractorService,
    private lookupService: LookupService,
    private customScoringService: CustomScoringService,
    private assessmentService : AssessmentService,
    private commonService: CommonService,
    private cdr: ChangeDetectorRef

  ) {
    this.setdefaultTranslator();
    this.getResponseValueType();
    this.currentRole = localStorage.getItem('role');
    if (this.currentRole === 'External User RW' || this.currentRole === 'External User RO') {
      this.isExternalUser = true;
    }
    this.assessmentIDfromUrl =
    this.route.snapshot.queryParamMap.get('assessmentID');

  }

  /**
 * Function to open modal
 */
  public openModal() {
    this.modalRef = this.modalService.show(this.elementView, {
      class: 'modal-dialog-centered',
    });
  }


  getResponseValueType() {
    this.questionnaireService.getResponseValueType().subscribe((res: any) => {
      this.responseValueType = res?.Data?.responseValueTypes;
      this.responseSliderType = this.responseValueType?.filter((element) => element.name === "Slider")[0]?.responseValueTypeID; // 3
      this.responseListType = this.responseValueType?.filter((element) => element.name === "Response List")[0]?.responseValueTypeID; //1
      this.responseTextType = this.responseValueType?.filter((element) => element.name === "Text")[0]?.responseValueTypeID; //2
      this.responseTextAreaType = this.responseValueType?.filter((element) => element.name === "TextArea")[0]?.responseValueTypeID; //4
      this.responseDateType = this.responseValueType?.filter((element) => element.name === "Date")[0]?.responseValueTypeID; //5
      this.responseCheckboxType = this.responseValueType?.filter((element) => element.name === "Checkbox")[0]?.responseValueTypeID; //6
      this.responseSignatureType = this.responseValueType?.filter((element) => element.name === "Signature")[0]?.responseValueTypeID; //8
      this.responseDoodleType = this.responseValueType?.filter((element) => element.name === "Doodle")[0]?.responseValueTypeID; //7
      this.responseAttachmentType = this.responseValueType?.filter((element) => element.name === "Attachment")[0]?.responseValueTypeID; //9
      this.responseDocuSignType = this.responseValueType?.filter((element) => element.name === "DocuSign")[0]?.responseValueTypeID;
      this.scoreResponseType = this.responseValueType?.filter((element) => element.name === "Score")[0]?.responseValueTypeID; //10
      this.scoreResponseListType = this.responseValueType?.filter((element) => element.name === "Score Response List")[0]?.responseValueTypeID; //11
      this.responseCustomListType = this.responseValueType?.filter((element) => element.name === 'ResponseCustomListType')[0]?.responseValueTypeID; //13
       });
  }

  ngOnInit() {
    // this.cookieService.deleteAll();
    // this.localStorageService.deleteAllLocalStorage();
    this.userName = this.localStorageService.getDataFromLocalStorage(
      localStorageVariables.username
    );
    this.interactorService.brandingDetailsCast.subscribe(data => {
      this.fileColor =
      this.brandingDetails?.branding?.BackgroundColors?.FileInput;
      document?.documentElement?.style.setProperty(
        '--fileColor',
        this.fileColor
      );
      document?.documentElement?.style.setProperty('--disableCategoryColor', this.brandingDetails?.branding?.BackgroundColors?.DisableCategoryColor);
    });
    this.qiService.valueChangesInviteToCompleteCast.subscribe((val) => {
      this.isChanged = val;
    });
    const hostname = window && window.location.hostname && window.location.hostname;
    this.shouldApplyMask =false;
    if(hostname.includes('2-login')){
      this.isMagellan = true;
    }
    this.assessmentReason = this.route.snapshot.queryParamMap.get('AssessmentReason');
    const assessmentReasonText = (this.assessmentReason != '' && this.assessmentReason != null) ? 'for the ' + this.assessmentReason + 'assessment' : '';
    this.otpText = 'A verification code has been generated' + assessmentReasonText + ' and sent to your email address. Please check your inbox and copy the code provided into the field below to begin.'
    const urlParams = new URLSearchParams(window.location.search);
    // Support both new 'ag' and legacy 'agencyId' parameters
    const agencyId = urlParams.get('ag') || urlParams.get('agencyId');
    this.agencyID = agencyId;
    const isFromAdvancedSearchStr = urlParams.get('isFromAdvancedSearch');
    const isConsentStr = urlParams.get('isConsent');
    this.isFromAdvancedSearch = isFromAdvancedSearchStr  == 'True' ? true : false;
    this.isConsent = isConsentStr  == 'True' ? true : false;
    this.getBrandingDetails(agencyId);
    if (urlParams.get('id')) {
      this.decryptId = encodeURIComponent(urlParams.get('id'));
      this.emailAssessment.assessmentOtp(this.decryptId).subscribe(
        (response) => {
          this.handleAssessmentOtpLoad(response);
        },
        (error:any) => {
          const statusCode = error?.StatusCode;
          if(statusCode==422){
            this.handleAssessmentOtpLoad(error);
          }

        }
      );
    }
  }

  downloadFile(file) {
    if (file.fileURL !== '') {
      const downloadLink = document.createElement('a');
      downloadLink.download = file.fileName;
      downloadLink.href = file.fileURL;
      downloadLink.click();
    } else {
      const linkSource =
        'data:application/octet-stream;base64,' + file.byteArray;
      const downloadLink = document.createElement('a');
      downloadLink.href = linkSource;
      downloadLink.download = file.fileName;
      downloadLink.click();
    }
  }

  removeFile(i, j, deleteIndex, isFromChild?) {
    const versionArray = this.questionCategories.at(i).get('versionItems') as UntypedFormArray;
    const responseArray = versionArray.at(j).get('Responses') as UntypedFormArray;
    const assesArray = versionArray.at(j).get('assesments') as UntypedFormArray;
    const index = assesArray
      .getRawValue()
      .findIndex((val) => val.assessmentID === this.assesmentNumber);
    if (!isFromChild) {
      const filesArray = assesArray.at(index).get('files') as UntypedFormArray;
      filesArray.removeAt(deleteIndex);
    } else {
      const childItems = versionArray.at(j).get('childItems') as UntypedFormArray;
      if (childItems?.value?.length) {
        childItems.getRawValue().forEach((group, g) => {
          let childGroup = childItems.at(g) as UntypedFormArray;
          group.forEach((childItemGroup, cg) => {
            let childItem = childGroup.at(cg) as UntypedFormArray;
            childItemGroup.forEach((child, i) => {
              let childControl = childItem.at(i).get('childValue') as FormControl;
              const filesArray = childItem.at(i).get('files') as UntypedFormArray;
              filesArray.removeAt(deleteIndex);
            });
          });
        });
      }
    }
  }


  getFiles(itemId, i, j, isFromChiLdItem) {
    let filesArray = new UntypedFormArray([]);
    const versionArray = this.questionCategories
      .at(i)
      .get('versionItems') as UntypedFormArray;
    const assesArray = versionArray.at(j).get('assesments') as UntypedFormArray;
    if (!isFromChiLdItem) {
      assesArray.getRawValue().forEach((element, index) => {
        if (this.assesmentNumber) {
          if (element.assessmentID === this.assesmentNumber) {
            filesArray = assesArray.at(index).get('files') as UntypedFormArray;
          }
        } else {
          const assesmentObj = assesArray
            .getRawValue()
            .reduce((a, b) =>
              a.assessmentResponseID > b.assessmentResponseID ? a : b
            );
          if (
            element.itemId === itemId &&
            element.assessmentResponseID === assesmentObj.assessmentResponseID
          ) {
            filesArray = assesArray.at(index).get('files') as UntypedFormArray;
          }
        }
      });
      return filesArray;
    } else {
      const childItems = versionArray.at(j).get('childItems') as UntypedFormArray;
      if (childItems?.value?.length) {
        childItems.getRawValue().forEach((group, g) => {
          let childGroup = childItems.at(g) as UntypedFormArray;
          group.forEach((childItemGroup, cg) => {
            let childItem = childGroup.at(cg) as UntypedFormArray;
            childItemGroup.forEach((child, i) => {
              let childControl = childItem.at(i).get('childValue') as FormControl;
              filesArray = childItem.at(i).get('files') as UntypedFormArray;
            });
          });
        });
      }
      return filesArray;
    }
  }


  CustomCallBack(event) {
    let image = this.signatureArray?.find(
      (val) => val.index === event.index && val.category === event.category
    );
    let IsItemInEditArray = this.inCompleteItemsArray?.find(
      (val) => val.index === event.index && val.category === event.category
    );
    if (IsItemInEditArray && !event.edit) {
      let index = this.inCompleteItemsArray.findIndex(val => val.index === event.index && val.category === event.category);
      this.inCompleteItemsArray.splice(index, 1)
    }
    if (event.image != "" || event.edit) {
      if (image) {
        let index = this.signatureArray.findIndex(val => val.index === event.index && val.category === event.category);
        if (index > -1)
          this.signatureArray.splice(index, 1)
      }
      this.signatureArray.push({
        image: event.image,
        index: event.index,
        category: event.category,
        original: event.original,
        group: event.group,
        groupItem: event.groupItem,
        child: event.child,
        isChildItem: event.isChildItem,
        childData: event.childData
      });
    } else {
      let index = this.signatureArray.findIndex(val => val.index === event.index && val.category === event.category);
      if (index > -1)
        this.signatureArray.splice(index, 1)
    }
    const versionArray = this.questionCategories?.at(event.category)?.get('versionItems') as UntypedFormArray;
    if (!event.isChildItem) {
      const responseArray = versionArray?.at(event.index)?.get('Responses') as UntypedFormArray;
      const response = responseArray?.getRawValue()?.find((val) => val.Value != '-');
      const assesArray = versionArray?.at(event.index)?.get('assesments') as UntypedFormArray;
      const index = assesArray?.getRawValue()?.findIndex((val) => val.assessmentID === this.assesmentNumber);
      assesArray?.at(index)?.get('ResponseId')?.setValue(response?.ResponseId);
      if (!event.edit && !event.image?.includes('https')) {
        assesArray.at(index).get('value')?.setValue(event.image);
        assesArray.at(index).get('imageValue')?.setValue(event.image);
      }
      this.findAssesmentSummation();
    } else {
      // Handle child item signature assignment - comprehensive handling for all scenarios
      const childItems = versionArray?.at(event.index)?.get('childItems') as UntypedFormArray;
      if (childItems && event.child !== undefined) {
        const childItem = childItems.at(event.child);
        if (childItem) {
          // Handle signature clearing - when signature is deleted or cleared
          if (!event.image || event.image.trim() === '') {
            childItem.patchValue({
              childValue: '',
              imageValue: ''
            });
            // Clear files array if it exists
            const filesArray = childItem.get('files') as UntypedFormArray;
            if (filesArray) {
              filesArray.clear();
            }
          } else {
            // Handle signature assignment - when signature is drawn or updated
            if (!event.edit && !event.image?.includes('https')) {
              childItem.patchValue({
                childValue: event.image,
                imageValue: event.image
              });
            }
          }
        }
      }
    }
  }
  CustomCallBackOnEdit(editData) {
    let item = this.inCompleteItemsArray?.find(
      (val) => val.index === editData.index && val.category === editData.category
    );
    if (!editData.remove && (!item || item?.length <= 0)) {
      this.inCompleteItemsArray.push(editData)
    } else {
      if (editData.remove && (item || item?.length > 0)) {
        let index = this.inCompleteItemsArray.findIndex(val => val.index === editData.index && val.category === editData.category);
        this.inCompleteItemsArray.splice(index, 1)
      }
    }
  }

  getSkipRules() {
    this.questionnaireService.getSkipRulesForEmail(this.emailassessmentData.questionnaireID).subscribe((response: any) => {
      this.hasSkipLogic = response.Data.hasSkipLogic;
      this.skipRules = response.Data.questionnaireSkipLogicRules;

    });
  }

  public skipQuestions() {
    if (this.hasSkipLogic && this.skipRules.length > 0) {
      const assessment = this.emailassessmentData.assessment;
      this.questionCategories.getRawValue().forEach((question, qIndex) => {
        const versionItem = this.questionCategories.at(qIndex).get('versionItems') as UntypedFormArray;
        this.questionCategories.at(qIndex).get('skippedCategory').setValue(false);
        versionItem?.getRawValue()?.forEach((version, vindex) => {
          let assesment = versionItem?.at(vindex)?.get('assesments') as UntypedFormArray;
          const aIndex = assesment?.getRawValue()?.findIndex(val => val.assessmentID === assessment.assessmentID);
          if (aIndex >= 0 && !version?.showRadioButton) {
            versionItem?.at(vindex)?.get('ResponseId')?.enable();
            versionItem?.at(vindex)?.get('resValue')?.enable();
            const childItems = versionItem?.at(vindex)?.get('childItems') as UntypedFormArray;
            assesment.getRawValue().forEach(element => {
              if (version.childItems?.length > 0) {
                version.childItems.forEach((child, index) => {
                  childItems.at(index).get('isHidden').setValue(false);
                });
              }
            });
            assesment.at(aIndex).get('showDropDown').setValue(true);
            assesment.at(aIndex).get('isSkipped').setValue(false);
          }
          if (version?.responseValueTypeID == this.responseSignatureType || version?.responseValueTypeID == this.responseDoodleType) {
            let isShowCard = versionItem?.at(vindex)?.get('isShowCard')?.value;
            versionItem?.at(vindex)?.get('isShowCard')?.setValue(!isShowCard);
            setTimeout(() => {
              versionItem?.at(vindex)?.get('isShowCard')?.setValue(isShowCard);
            });
          }
        });
      });
      this.skipActions = this.SkipLogicService.getSkipDetails(this.questionCategories.getRawValue(), assessment.assessmentID, this.skipRules);
      if (this.skipActions?.length > 0) {
        this.skipActions.forEach(action => {
          if (action?.actionTypeName === 'Category') {
            const index = this.questionCategories.getRawValue().findIndex(val => val.CategoryId === action.categoryID);
            const versionItem = this.questionCategories.at(index).get('versionItems') as UntypedFormArray;
            this.questionCategories.at(index).get('skippedCategory').setValue(true);
            versionItem?.getRawValue().forEach((version, vindex) => {
              let assesment = versionItem?.at(vindex)?.get('assesments') as UntypedFormArray;
              const aIndex = assesment?.getRawValue()?.findIndex(val => (val.assessmentID === assessment.assessmentID));
              if (aIndex >= 0) {
                versionItem?.at(vindex)?.get('ResponseId')?.disable();
                versionItem?.at(vindex)?.get('ResponseId')?.setValue('-');
                versionItem?.at(vindex)?.get('resValue')?.disable();
                versionItem?.at(vindex)?.get('resValue')?.setValue('-');
                versionItem?.at(vindex)?.get('displayChildItem')?.setValue(false);
                assesment.at(aIndex).get('showDropDown').setValue(false);
                assesment.at(aIndex).get('isSkipped').setValue(true);
                assesment.at(aIndex).get('value').setValue('-');
                assesment.at(aIndex).get('ResponseId').setValue('-');
                assesment.at(aIndex)?.get('imageValue')?.setValue('');
                assesment.at(aIndex)?.get('childItemResponses')?.setValue('');
                if(this.signatureArray && this.signatureArray.length>0){
                let versionItemSignatureList :any = this.signatureArray?.filter((val) => val.index === vindex && val?.category === index  && val?.isChildItem === true);
                if(versionItemSignatureList && versionItemSignatureList.length>0){
                  versionItemSignatureList?.forEach(element => {
                let signatureIndex = this.signatureArray?.findIndex((val) => val.index === element.index && val?.category === element?.category && val.group === element.group && val.groupItem == element.groupItem && val.isChildItem === element.isChildItem);
                if (signatureIndex > -1) this.signatureArray?.splice(signatureIndex, 1);
                  });
                }
                let versionItemParentSignatureList :any = this.signatureArray?.filter((val) => val.index === vindex && val?.category === index  && !val?.isChildItem );
                  if(versionItemParentSignatureList && versionItemParentSignatureList.length>0){
                    versionItemParentSignatureList?.forEach(element => {
                      let signatureIndex = this.signatureArray.findIndex(val => val.index === element.index && val?.category === element?.category);
                      if (signatureIndex > -1) this.signatureArray?.splice(signatureIndex, 1);
                    });
                  }
              }
              let filesArray = assesment.at(aIndex).get('files') as UntypedFormArray;
              filesArray.clear();
              let newAssessmentNotes = assesment.at(aIndex).get('note') as UntypedFormArray;
              newAssessmentNotes.clear();
              versionItem?.at(vindex)?.get('noteText')?.setValue(null);
              versionItem?.at(vindex)?.get('showAddNote')?.setValue(false);
              if (versionItem?.at(vindex)?.get('childItems')?.value?.length > 0) {
                const childItems = versionItem?.at(vindex)?.get('childItems') as UntypedFormArray;
                if (version.childItems && Array.isArray(version.childItems)) {
                version.childItems.forEach((child, cindex) => {
                  this.clearchildResponse(childItems, cindex, child);
                });
                }
              }

                this.findAssesmentSummation();
              }
            });
          } else if (action?.actionTypeName === 'Item') {
            this.questionCategories.getRawValue().forEach((question, qIndex) => {
              const versionItem = this.questionCategories.at(qIndex).get('versionItems') as UntypedFormArray;
              versionItem?.getRawValue()?.forEach((version, vindex) => {
                let assesment = versionItem?.at(vindex)?.get('assesments') as UntypedFormArray;
                const aIndex = assesment?.getRawValue()?.findIndex(val => (val.itemId === action.itemID) && (val.assessmentID === assessment.assessmentID));
                if (aIndex >= 0) {
                  versionItem?.at(vindex)?.get('ResponseId')?.disable();
                  versionItem?.at(vindex)?.get('ResponseId')?.setValue('-');
                  versionItem?.at(vindex)?.get('resValue')?.disable();
                  versionItem?.at(vindex)?.get('resValue')?.setValue('-');
                  versionItem?.at(vindex)?.get('displayChildItem')?.setValue(false);
                  assesment.at(aIndex).get('showDropDown').setValue(false);
                  assesment.at(aIndex).get('isSkipped').setValue(true);
                  assesment.at(aIndex).get('value').setValue('-');
                  assesment.at(aIndex).get('ResponseId').setValue('-');
                  assesment?.at(aIndex)?.get('imageValue')?.setValue('');
                  assesment?.at(aIndex)?.get('childItemResponses')?.setValue('');
                  if(this.signatureArray && this.signatureArray.length>0){
                  let versionItemSignatureList :any = this.signatureArray?.filter((val) => val.index === vindex && val.category === qIndex  && val.isChildItem === true);
                  if(versionItemSignatureList && versionItemSignatureList.length>0){
                    versionItemSignatureList?.forEach(element => {
                  let signatureIndex = this.signatureArray?.findIndex((val) => val.index === element.index && val.category === element.category && val.group === element.group && val.groupItem == element.groupItem && val.isChildItem === element.isChildItem);
                  if (signatureIndex > -1) this.signatureArray?.splice(signatureIndex, 1);
                    });
                  }
                  let versionItemParentSignatureList :any = this.signatureArray?.filter((val) => val.index === vindex && val?.category === qIndex  && !val?.isChildItem );
                  if(versionItemParentSignatureList && versionItemParentSignatureList.length>0){
                    versionItemParentSignatureList?.forEach(element => {
                      let signatureIndex = this.signatureArray.findIndex(val => val.index === element.index && val.category === element.category);
                      if (signatureIndex > -1) this.signatureArray.splice(signatureIndex, 1);
                    });
                  }
                }
                let filesArray = assesment.at(aIndex).get('files') as UntypedFormArray;
                filesArray.clear();
                let newAssessmentNotes = assesment.at(aIndex).get('note') as UntypedFormArray;
                newAssessmentNotes.clear();
                versionItem?.at(vindex)?.get('noteText')?.setValue(null);
                versionItem?.at(vindex)?.get('showAddNote')?.setValue(false);
                if (versionItem?.at(vindex)?.get('childItems')?.value?.length > 0) {
                    const childItems = versionItem?.at(vindex)?.get('childItems') as UntypedFormArray;
                    if (version.childItems && Array.isArray(version.childItems)) {
                      version.childItems.forEach((child, cindex) => {
                      this.clearchildResponse(childItems, cindex, child);
                      });
                    }
                  }
                  this.findAssesmentSummation();
                }
              });
            });
          } else {
            this.questionCategories.getRawValue().forEach((question, qIndex) => {
              const versionItem = this.questionCategories.at(qIndex).get('versionItems') as UntypedFormArray;
              versionItem?.getRawValue()?.forEach((version, vindex) => {
                const assessment = versionItem?.at(vindex)?.get('assesments') as UntypedFormArray;
                const childItems = versionItem?.at(vindex)?.get('childItems') as UntypedFormArray;
                assessment.getRawValue().forEach(element => {
                  if (version.childItems?.length > 0) {
                    version.childItems.forEach((child, index) => {
                      if (child.ChildItemID === action.childItemID && action.parentItemID === child.ParentItemID) {
                        childItems.at(index).get('isHidden').setValue(true);
                        childItems.at(index).get('ResponseId').setValue('-');
                        if (child.ResponseValueTypeID === this.responseListType) {
                          childItems.at(index).get('childValue').setValue('-');
                        } else if (child.ResponseValueTypeID === this.responseTextType) {
                          childItems.at(index).get('childValue').setValue('');
                        } else if (child.ResponseValueTypeID === this.responseSliderType) {
                          childItems.at(index).get('childValue').setValue(0);
                        } else if (child.ResponseValueTypeID === this.responseTextAreaType) {
                          childItems.at(index).get('childValue').setValue('');
                        } else if (child.ResponseValueTypeID === this.responseDateType) {
                          childItems.at(index).get('childValue').setValue(null);
                        } else if (child.ResponseValueTypeID === this.responseCheckboxType) {
                          childItems.at(index).get('childValue').setValue(false);
                        } else if (child.ResponseValueTypeID === this.responseSignatureType) {
                          childItems.at(index).get('childValue').setValue(null);
                          childItems.at(index).get('imageValue').setValue('');
                          let filesArray = childItems.at(index).get('files') as UntypedFormArray;
                          filesArray.clear();

                          // Clear signatureArray entries for this child item
                          if(this.signatureArray && this.signatureArray.length > 0){
                            let versionItemSignatureList = this.signatureArray?.filter((val) => val.index === vindex && val.category === qIndex && val.isChildItem === true && val.childData?.ChildItemID === child.ChildItemID);
                            if(versionItemSignatureList && versionItemSignatureList.length > 0){
                              versionItemSignatureList?.forEach(element => {
                                let signatureIndex = this.signatureArray?.findIndex((val) => val.index === element.index && val.category === element.category && val.group === element.group && val.groupItem == element.groupItem && val.isChildItem === element.isChildItem && val.childData?.ChildItemID === element.childData?.ChildItemID);
                                if (signatureIndex > -1) this.signatureArray?.splice(signatureIndex, 1);
                              });
                            }
                          }
                        } else if (child.ResponseValueTypeID === this.responseDoodleType) {
                          childItems.at(index).get('childValue').setValue(null);
                          childItems.at(index).get('imageValue').setValue('');
                          let filesArray = childItems.at(index).get('files') as UntypedFormArray;
                          filesArray.clear();

                          // Clear signatureArray entries for this child item
                          if(this.signatureArray && this.signatureArray.length > 0){
                            let versionItemSignatureList = this.signatureArray?.filter((val) => val.index === vindex && val.category === qIndex && val.isChildItem === true && val.childData?.ChildItemID === child.ChildItemID);
                            if(versionItemSignatureList && versionItemSignatureList.length > 0){
                              versionItemSignatureList?.forEach(element => {
                                let signatureIndex = this.signatureArray?.findIndex((val) => val.index === element.index && val.category === element.category && val.group === element.group && val.groupItem == element.groupItem && val.isChildItem === element.isChildItem && val.childData?.ChildItemID === element.childData?.ChildItemID);
                                if (signatureIndex > -1) this.signatureArray?.splice(signatureIndex, 1);
                              });
                            }
                          }
                        } else if (child.ResponseValueTypeID === this.responseAttachmentType) {
                          childItems.at(index).get('childValue').setValue(null);
                          childItems.at(index).get('imageValue').setValue('');
                          let filesArray = childItems.at(index).get('files') as UntypedFormArray;
                          filesArray.clear();
                        }
                        else if (child.ResponseValueTypeID === this.responseCustomListType) {
                          childItems.at(index).get('childValue').setValue('-');
                        }
                        this.findAssesmentSummation();
                      }
                    });
                  }
                });
              });
            });
          }
        });
      }
    }
  }
  getScoringRules() {
    this.qService.getScoringDetailsForInviteToComplete(this.emailassessmentData?.questionnaireID).subscribe((response: any) => {
      this.scoreResponseList = response.Data?.scoreResponseList;
      this.scoreResponse = response.Data?.scoreResponse;
      this.scoreResponseList?.forEach(score => {
        this.scoreResponse.push(score)
      });
    });
  }

  public setScoringLogic() {
    if (this.scoreResponse?.length > 0 || this.scoreResponseList?.length > 0) {
      const assessment = this.emailassessmentData.assessment;
      let scoreDetailsData = this.scoreResponse;
      scoreDetailsData?.forEach(score => {
        let scoreData = score;
        let scoreDetails = this.customScoringService.getScoreDetails(this.questionCategories.getRawValue(), scoreData, assessment.assessmentID);
        if (scoreData.responseValueTypeID == this.scoreResponseType) {
          this.questionCategories.getRawValue().forEach((question, qIndex) => {
            const versionItem = this.questionCategories.at(qIndex).get('versionItems') as UntypedFormArray;
            versionItem?.getRawValue()?.forEach((version, vindex) => {
              if (version.responseValueTypeID === this.scoreResponseType) {
                // const questionnaireItemID =  version.QuestionnaireItemID;

                let response = version?.Responses?.find(val => val.ResponseId !== '-')
                let assesments = versionItem?.at(vindex)?.get('assesments') as UntypedFormArray;
                const aIndex = assesments.getRawValue().findIndex(val => val.assessmentID === assessment.assessmentID);
                assesments.getRawValue().forEach(assesment => {
                  if (assesment.itemId === scoreDetails?.itemId) {
                    assesments.at(aIndex).get('value').setValue(scoreDetails?.value);
                    assesments.at(aIndex).get('ResponseId').setValue(response?.ResponseId);
                    versionItem?.at(vindex)?.get('ResponseId')?.setValue(response?.ResponseId);
                    versionItem?.at(vindex)?.get('resValue')?.setValue(scoreDetails?.value);
                    let assessmentControl = assesments.at(aIndex).get('ResponseId') as FormControl;
                    assessmentControl.setErrors(null);
                    // this.setItemResponseBehaviorId(version.QuestionnaireItemID);
                  }
                });
              }
            });
          });
        } else if (scoreData.responseValueTypeID == this.scoreResponseListType) {
          this.questionCategories.getRawValue().forEach((question, qIndex) => {
            const versionItem = this.questionCategories.at(qIndex).get('versionItems') as UntypedFormArray;
            versionItem?.getRawValue()?.forEach((version, vindex) => {
              if (version.responseValueTypeID === this.scoreResponseListType) {
                let scoreResponseObject = scoreData?.scoreDetailList?.find(val => val.value === true);
                let response;
                if (scoreResponseObject) {
                  response = version?.Responses?.find(val => val.ResponseId === scoreResponseObject.responseID);
                } else {
                  response = version?.Responses?.find(val => val.ResponseId === '-');
                }
                let assesments = versionItem?.at(vindex)?.get('assesments') as UntypedFormArray;
                const aIndex = assesments.getRawValue().findIndex(val => val.assessmentID === assessment.assessmentID);
                assesments.getRawValue().forEach(assesment => {
                  if (assesment.assessmentID === assessment.assessmentID && assesment.itemId === scoreDetails?.itemId) {
                    assesments.at(aIndex).get('value').setValue(response?.Value);
                    versionItem?.at(vindex)?.get('ResponseId')?.setValue(response?.ResponseId);
                    assesments?.at(aIndex)?.get('ResponseId')?.setValue(response?.ResponseId);
                    versionItem?.at(vindex)?.get('resValue')?.setValue(response?.Value);
                    let assessmentControl = assesments.at(aIndex).get('ResponseId') as FormControl;
                    assessmentControl.setErrors(null);
                  }
                });
              }
            });
          });
        }
      });
      this.findAssesmentSummation();
    }
  }

  public checkScore(scoreValue) {
    if (isNaN(scoreValue)) {
      return '-'
    } else {
      return scoreValue
    }
  }

  /**
   * validate Otp Response
   * @param object otpSendResponse
   */
  validateOtpResponse(otpSendResponse: any) {
    this.invalidStatusCode = otpSendResponse?.responseStatusCode
    if (otpSendResponse?.responseStatusCode === 1028) {
      this.errorMessage = 'Assessment already submitted.';
      this.isRequestInvalid = true;
      return false;
    } else if (otpSendResponse?.responseStatusCode === 1027) {
      this.errorMessage = 'This link has expired.';
      this.enableResendLink = true;
      this.isRequestInvalid = true;
      return false;
    } else if (otpSendResponse?.responseStatusCode === 1018) {
      this.errorMessage = 'Failed to send mail.';
      this.isRequestInvalid = true;
      return false;
    } else if (otpSendResponse?.responseStatusCode === 1030) {
      this.errorMessage = 'Email assessment no longer required.';
      this.isRequestInvalid = true;
      return false;
    }
    return true;
  }

  private handleAssessmentOtpLoad(response: any) {
      if (response) {
            this.inviteToCompleteHtmlContent =(response?.Data?.inviteToCompleteHtmlContent)? this.sanitizer.bypassSecurityTrustHtml(response?.Data?.inviteToCompleteHtmlContent): null;
            if (this.validateOtpResponse(response)) {
              const otpSendResponse = response.Data;
              this.agencyLanguageId = otpSendResponse?.agencyLanguageID;
              if (this.validateOtpResponse(otpSendResponse) && !otpSendResponse.isOTPVerificationNeeded) {
                this.isAuth = true;
                this.initOtp();
                this.code.setValue(otpSendResponse?.assessmentEmailOtpID + "");
                this.startAssessment();
              }
              if (this.validateOtpResponse(otpSendResponse) && otpSendResponse.isOTPVerificationNeeded) {
                this.initOtp();
              }
            }
          }

}

  get code() {
    return this.otpVerification.get('code');
  }

  get questionCategories() {
    if (this.questionForm && this.questionForm.controls.category) {
      return this.questionForm.controls.category as UntypedFormArray;
    }
  }

  initOtp() {
    this.otpVerification = this.formBuilder.group({
      code: new UntypedFormControl('', [Validators.required]),
    });
  }

  /**
   * Otp verification
   */
  startAssessment() {
    if (this.code.value.trim()) {
      const assessmentData = {
        otp: this.code.value,
        decryptUrl: this.decryptId,
      };
      // tslint:disable-next-line: deprecation
      this.emailAssessment.assessmentOtpVerification(assessmentData).subscribe(
        (response) => {
          if (response.Data.responseStatusCode === 1010) {
            this.isAuth = true;
            this.getAnonymousLanguagesList(response.Data);
          } else {
            if (response.Data.responseStatusCode === 1026) {
              this.toastMessage('Invalid OTP.');
            } else if (response.Data.responseStatusCode === 1029) {
              this.toastMessage('OTP is expired.');
            } else if (response.Data.responseStatusCode === 1027) {
              this.toastMessage('This link has expired.');
            } else {
              this.toastMessage(response.Message);
            }
          }
        },
        (error) => { }
      );
    } else {
      this.toastMessage('Please enter a valid verification code.');
    }
  }

  /**
   * show error message
   * @param string message
   */
  toastMessage(message) {
    let toastText = '';
    this.translatorService.get(message).subscribe(translatesText => {
      toastText = translatesText;
    });
    this.toastr.error(toastText, '', {
      positionClass: 'toast-bottom-right',
    });
  }

  /**
   * set params
   * @param object response
   */
  loadEmailAssessmentForm(response: any) {
    this.emailassessmentData = response.assessmentEmailLinkDetails;
    this.assesmentNumber=this.emailassessmentData.assessment.assessmentID;
    this.personSupportID = this.emailassessmentData?.personSupportID;
    this.personSupports = this.emailassessmentData.personSupports;
    this.currentSupportData = this.emailassessmentData.personSupports?.find((support) => support?.personSupportID == this.personSupportID);
    this.initializeForm();
    this.getQuestionsDetails();
    this.validQuestionEndDate();
    this.getSkipRules();
    this.getScoringRules();
  }

  getBrandingDetails(agencyId) {
    this.emailAssessment.getBrandingDetailsAnonymously(agencyId).subscribe(
      (res) => {
        if (res.StatusCode !== 200) {
          this.message = res.Message;
        } else {
          this.brandingDetails = res.Data;
          this.interactorService.changeInviteToCompleteBrandingDetails(this.brandingDetails);
          this.matTealDark = this.brandingDetails?.branding?.MatColors?.MatTealDark;
          this.boldFont = this.brandingDetails?.branding?.Font?.BoldFont;
          this.regularFont = this.brandingDetails?.branding?.Font?.RegularFont;
          this.badgeColor = this.brandingDetails?.branding?.BackgroundColors?.Badge;
          this.overlayColor = this.brandingDetails?.branding?.BackgroundColors?.Overlay;
          this.fontFamily = this.brandingDetails?.branding?.BackgroundColors?.InsertColor;
          this.whiteColor = this.brandingDetails?.branding?.BackgroundColors?.WhitePaginationBackground;
          this.lightgrayColor = this.brandingDetails?.branding?.BackgroundColors?.DisabledHeaderBackground;
          this.afterSave = this.brandingDetails?.branding?.BackgroundColors?.GridBorder;
          this.blackColor = this.brandingDetails?.branding?.BackgroundColors?.NotesExpandButtonHover;
          this.semiBoldFont = this.brandingDetails?.branding?.Font?.SemiBoldFont;
          this.approveReject = this.brandingDetails?.branding?.BackgroundColors?.BtnLogoContainer;
          this.disableColor = this.brandingDetails?.branding?.BackgroundColors?.DisabledBackground;
          this.alternateRows = this.brandingDetails?.branding?.BackgroundColors.AlternateRows;
          this.headerColor = this.brandingDetails?.branding?.BackgroundColors.Headers;
          this.styleColor = this.brandingDetails?.branding?.BackgroundColors.StyledBorderBottom;
          this.infoIconColor = this.brandingDetails?.branding?.BackgroundColors.Notification1;
          this.headerFontColor = this.brandingDetails?.branding?.BackgroundColors?.HeaderFontColor;
          this.questionnaireCardBackground = this.brandingDetails?.branding?.BackgroundColors?.QuestionnaireCardBackground;
          this.questionnaireCardTableBackground = this.brandingDetails?.branding?.BackgroundColors?.QuestionnaireCardTableBackground;
          this.matWhite = this.brandingDetails?.branding?.MatColors?.MatWhite;
          this.buttonFont = this.brandingDetails?.branding?.BackgroundColors?.BtnFont;
          this.greyLightBg = this.brandingDetails?.branding?.BackgroundColors?.SideBarBackground;
          this.button2 = this.brandingDetails?.branding.BackgroundColors?.Button2;
          this.redBtn = this.brandingDetails?.branding.BackgroundColors?.BtnRed;
          this.greenBtn = this.brandingDetails?.branding.BackgroundColors?.BtnGreen;
          this.linkButtons = this.brandingDetails?.branding.BackgroundColors?.LinkButtons;
          this.headerBackground = this.brandingDetails?.branding?.BackgroundColors?.Headers;
          this.tableHeadColor = this.brandingDetails?.branding?.BackgroundColors?.TableHeadColor;
          this.btnLightBlue = this.brandingDetails?.branding?.BackgroundColors?.ResendColor;
          this.notification1 = this.brandingDetails?.branding?.BackgroundColors?.Notification1;
          this.redBorder = this.brandingDetails?.branding?.BackgroundColors?.RequiredAsterisk;
          this.confirmDeleteBtn = this.brandingDetails?.branding.BackgroundColors?.ConfirmDeleteBtn;
          this.confirmCancelBtn = this.brandingDetails?.branding.BackgroundColors?.ConfirmCancelBtn;
          this.ConfirmDeleteBtnHover = this.brandingDetails?.branding.BackgroundColors?.ConfirmDeleteBtnHover;
          this.fileColor = this.brandingDetails?.branding?.BackgroundColors?.FileInput;

          document.documentElement.style.setProperty('--redBorder', this.redBorder);
          document.documentElement.style.setProperty('--notification1', this.notification1);
          document.documentElement.style.setProperty('--buttonFont', this.buttonFont);
          document.documentElement.style.setProperty('--button2', this.button2);
          document.documentElement.style.setProperty('--matWhite', this.matWhite);
          document.documentElement.style.setProperty('--matTealDark', this.matTealDark);
          document.documentElement.style.setProperty('--boldFont', this.boldFont);
          document.documentElement.style.setProperty('--regularFont', this.regularFont);
          document.documentElement.style.setProperty('--badgeColor', this.badgeColor);
          document.documentElement.style.setProperty('--overlayColor', this.overlayColor);
          document.documentElement.style.setProperty('--approveReject', this.approveReject);
          document.documentElement.style.setProperty('--disableColor', this.disableColor);
          document.documentElement.style.setProperty('--fontFamily', this.fontFamily);
          document.documentElement.style.setProperty('--whiteColor', this.whiteColor);
          document.documentElement.style.setProperty('--lightgrayColor', this.lightgrayColor);
          document.documentElement.style.setProperty('--afterSave', this.afterSave);
          document.documentElement.style.setProperty('--blackColor', this.blackColor);
          document.documentElement.style.setProperty('--semiBoldFont', this.semiBoldFont);
          document.documentElement.style.setProperty('--headerColor', this.headerColor);
          document.documentElement.style.setProperty('--styleColor', this.styleColor);
          document.documentElement.style.setProperty('--alternateRows', this.alternateRows);
          document.documentElement.style.setProperty('--infoIconColor', this.infoIconColor);
          document.documentElement.style.setProperty('--headerFontColor', this.headerFontColor);
          document.documentElement.style.setProperty('--questionnaireCardBackground', this.questionnaireCardBackground);
          document.documentElement.style.setProperty('--questionnaireCardTableBackground', this.questionnaireCardTableBackground);
          document.documentElement.style.setProperty('--greyLightBg', this.greyLightBg);
          document.documentElement.style.setProperty('--redBtn', this.redBtn);
          document.documentElement.style.setProperty('--greenBtn', this.greenBtn);
          document.documentElement.style.setProperty('--linkButtons', this.linkButtons);
          document.documentElement.style.setProperty('--headerBackground', this.headerBackground);
          document.documentElement.style.setProperty('--tableHeadColor', this.tableHeadColor);
          document.documentElement.style.setProperty('--btnLightBlue', this.btnLightBlue);
          document.documentElement.style.setProperty('--confirmDeleteBtn', this.confirmDeleteBtn);
          document.documentElement.style.setProperty('--confirmCancelBtn', this.confirmCancelBtn);
          document.documentElement.style.setProperty('--confirmDeleteBtnHover', this.ConfirmDeleteBtnHover);
          document?.documentElement?.style.setProperty('--fileColor', this.fileColor);
        }
      },
      (err) => {
        this.message = err.Message;
      }
    );
  }
  getAnonymousLanguagesList(assessmentOtpVerificationData?: any){
     this.lookupService.getAnonymousLanguages().subscribe(
        (res) => {
          if (res.StatusCode !== 200) {
            this.message = res.Message;
          } else {
            // Defensive: Ensure languages array exists and is not empty
            this.languages = Array.isArray(res?.Data?.agencyLanguage) ? res.Data.agencyLanguage : [];
            let currentLanguage: any = null;
            if (this.agencyLanguageId) {
            currentLanguage = this.languages?.find(x => x.agencyLanguageID == this.agencyLanguageId);
            }
            // Fallback to English if not found
            if (!currentLanguage) {
            currentLanguage = this.languages?.find(x => x.attribute === 'en');
            }
            // Fallback to first language if still not found
            if (!currentLanguage) {
            currentLanguage = this.languages?.[0];
            }
          this.language = currentLanguage?.attribute || 'en';
          this.previousLanguage = this.language;
          this.setdefaultTranslator();
          this.lookupService.setEmailLanguage(currentLanguage);
          this.loadEmailAssessmentForm(assessmentOtpVerificationData);
          }
        },
        (err) => {
          this.message = err.Message;
        }
      );
  }

  setDefaultResponses(supportFocusCategoriesOnly: boolean = false, categoryIndex: number = null) {
    if (this.questionCategories) {
      this.questionCategories.getRawValue().map((j: any, catIndex: number) => {
        const category = this.questionCategories.at(catIndex) as UntypedFormGroup;
        const items = category.get('versionItems') as UntypedFormArray;
        const categoryControls = category.controls;

        if (categoryControls.FocusId.value === 2 && categoryControls.supportID.value === null) {
          // user needs to select a support person first
          return;
        }

        if (supportFocusCategoriesOnly && categoryControls.FocusId.value !== 2) {
          // we only want to update categories with focusID = 2
          return;
        }

        if (supportFocusCategoriesOnly && catIndex !== categoryIndex) {
          // we only want to update the specific categoryIndex
          return;
        }

        items.getRawValue().map((z: UntypedFormGroup, itemIndex) => {
          const item = items.at(itemIndex) as UntypedFormGroup;
          const defaultValue = item.get('DefaultResponseID').value;

          const versionArray = this.questionCategories.at(catIndex).get('versionItems') as UntypedFormArray;
          const assesmentArray = versionArray.at(itemIndex).get('assesments') as UntypedFormArray;
          const assessmentValue = assesmentArray.at(0).get('value')?.value;

          let startDate = versionArray.at(itemIndex).get('startDate')?.value;
          let endDate = versionArray.at(itemIndex).get('endDate')?.value;
          const today = moment(moment(this.today).format('YYYY-MM-DD'));

          if (startDate) {
            startDate = moment(startDate).format('YYYY-MM-DD');
            if (today.isBefore(startDate)) {
              // do not set default response if the item is not yet active
              return;
            }
          }

          if (endDate) {
            endDate = moment(endDate).format('YYYY-MM-DD');
            if (today.isAfter(endDate)) {
              // do not set default response if the item is expired
              return;
            }
          }

          if (assessmentValue !== '-' && assessmentValue !== null) {
            // do not set default response if the assessment already has a response
            return;
          }

          if (defaultValue && defaultValue !== '-') {
            const event = {
              value: defaultValue
            };

            if (item.value.responseValueTypeID !== this.responseSignatureType || item.value.responseValueTypeID === this.responseDoodleType) {
              if (item?.value?.IsResponseIdAvailable) {
                this.setQsResponse(event, item.controls, catIndex, itemIndex);
                this.onQsSelectChange(event, item.controls);
                this.setResponseValueFromResponseId(catIndex, itemIndex);
              }
            }
          }
        });
      });
    }
  }

  hamburgerOpen = () => {
    if (window.innerWidth <= 1024) {
      const menuOverlay: any = document.getElementById('overlay');
      const btnHamburger: any = document.getElementById('hamburgerBtn');
      const navSidebar: any = document.getElementById('sidebar');
      btnHamburger.style.display = 'none';
      navSidebar.style.width = '200px';
      navSidebar.style.transform = 'translate3d(0vw, 0, 0)';
      navSidebar.style.transition = '0.4s';
      menuOverlay.style.display = 'block';
      menuOverlay.style.backgroundColor = 'rgba(0,0,0,0.5)';
    }
  }

  closeSidebar = () => {
    if (window.innerWidth <= 1024) {
      const menuOverlay: any = document.getElementById('overlay');
      const btnHamburger: any = document.getElementById('hamburgerBtn');
      const navSidebar: any = document.getElementById('sidebar');
      btnHamburger.style.display = 'block';
      navSidebar.style.width = '0px';
      navSidebar.style.transform = 'translate3d(-100vw, 0, 0)';
      navSidebar.style.transition = '0.9s';
      menuOverlay.style.display = 'none';
      menuOverlay.style.backgroundColor = 'rgba(0,0,0,0)';
    }
  }
  formatLabel(value: number) {
    return value;
  }
  /**
   * Resent otp
   */
  resendOtp() {
    // tslint:disable-next-line: deprecation
    this.emailAssessment.resendAssessmentOtp(this.decryptId).subscribe(
      (response) => {
        if (this.validateOtpResponse(response)) {
          // tslint:disable-next-line: triple-equals
          if (response.Data.responseStatusCode == 1037) {
            let toastText = '';
            this.translatorService.get(response.Data.responseStatus).subscribe(translatesText => {
              toastText = translatesText;
            });
            this.toastr.error(toastText, '', {
              positionClass: 'toast-bottom-right',
            });
          } else {
            let toastText = '';
            this.translatorService.get(validationMessage.otpSuccess).subscribe(translatesText => {
              toastText = translatesText;
            });
            this.toastr.success(toastText, '', {
              positionClass: 'toast-bottom-right',
            });
          }
        }
      },
      (error) => { }
    );
  }

  initializeForm() {
    this.questionForm = this.formBuilder.group({
      category: new UntypedFormArray([]),
    });
  }

  /**
   * get Questions Details
   */
  getQuestionsDetails() {
    const questionairId = this.emailassessmentData.questionnaireID;
    // tslint:disable-next-line: deprecation
    this.emailAssessment.getQuestionsAnonymously(questionairId,this.agencyID).subscribe(
      (response) => {
        this.questionsAndDetails = response.Data.questions;
        this.fullAddressList=response?.Data?.address;
        this.requiredConfidentialityLanguage = response.Data.questions.requiredConfidentialityLanguage;
        this.otherConfidentialityLanguage = response.Data.questions.otherConfidentialityLanguage;
        this.personRequestedConfidentialityLanguage = response.Data.questions.personRequestedConfidentialityLanguage;
        this.categories = this.questionsAndDetails.categories;
        this.isEnabledasterisk = response.Data.questions.isEnabledasterisk;
        this.instrumentID = response.Data.questions?.instrumentID;
        this.populateCategories();
      },
      (error) => { }
    );
    this.validQuestionEndDate();
  }
  /**
   * populate Categories
   */
  populateCategories() {
    this.categories.forEach((category) => {
      if (!(this.personSupportID == null && category.FocusId == 2)) {
        this.questionCategories.push(
          this.formBuilder.group({
            CategoryName: new UntypedFormControl(category.CategoryName),
            CategoryId: new UntypedFormControl(category.CategoryId),
            FocusId: new UntypedFormControl(category.FocusId),
            CategoryDescription: new UntypedFormControl(category.CategoryDescription),
            versionItems: this.populateVersionItems(category.VersionItems, {
              catId: category.CategoryId,
              focusId: category.FocusId,
              type: null,
            },category.IsCategoryExpiry),
            caregiverName: new UntypedFormControl(null),
            personSupportID: new UntypedFormControl(null),
            assesmentValues: this.populateAssesment(),
            summation: new UntypedFormControl(0),
            percentage: new UntypedFormControl(0),
            progressBarColor: new UntypedFormControl(null),
            showCategory: new UntypedFormControl(true),
            showSupportDropDown: new UntypedFormControl(
              category.FocusId === 2 ? true : false
            ),
            isCaregiver: new UntypedFormControl(category.FocusId === 2 ? true : false),
            supportID: this.personSupportID ?
            new UntypedFormControl({ value: this.personSupportID, disabled: true }):
            new UntypedFormControl({ value: null, disabled: false }),
            updateUserID: new UntypedFormControl(1),
            skippedCategory: new UntypedFormControl(false),
            IsCategoryExpiry: new UntypedFormControl(this.isAllQuestionsExpired(category)),
            ExcludeFromInviteToComplete: new UntypedFormControl(category.ExcludeFromInviteToComplete),
          })
        );
      }
    });
    this.questionCategoryArray = this.questionCategories.value;
    this.validQuestionEndDate();
    this.setDefaultResponses();
    this.setInviteToCompleteValueChange(false);
    // PCIS-10708: attach email pattern validator to value controls for ItemFormat === 'email' items
    this.applyItemFormatValidators();
  }

    /**
   * Checks if all questions in a category have expired based on their end dates
   * @param {any} category - The category object containing VersionItems with EndDate properties
   * @returns {boolean} Returns true if all version items in the category are expired, false if any are still valid
   */
  isAllQuestionsExpired(category) {
    const todayFormatted = moment(this.today).format('YYYY-MM-DD');
    let allExpired = true;
    category?.VersionItems?.forEach((version) => {
        const endDateFormatted = moment(version?.EndDate).format('YYYY-MM-DD');
        const isExpired = moment(todayFormatted).isAfter(endDateFormatted);
        if (!isExpired) {
          allExpired = false;
        }
    });
    return allExpired;
  }


  /**
   * populate Version Items
   * @param object versionItem
   * @param object catObj
   */
  populateVersionItems(versionItem: any, catObj?: any,IsCategoryExpiry? : any) {
    if (versionItem) {
      versionItem.assessmentdropdown = [];
    }
    const versionArray = new UntypedFormArray([]);
    versionItem?.forEach((element) => {
      versionArray.push(
        this.formBuilder.group({
          Description: new UntypedFormControl(this.getDescriptionText(element?.Description ? element?.Description : '')),
          ItemId: new UntypedFormControl(element?.ItemId),
          ListOrder: new UntypedFormControl(element?.ListOrder),
          QuestionnaireItemID: new UntypedFormControl(element?.QuestionnaireItemID),
          IsResponseIdAvailable: new UntypedFormControl(element?.IsResponseIdAvailable),
          IsChildItemReceiver: new UntypedFormControl(element?.IsChildItemReceiver),
          SenderItemID: new UntypedFormControl(element?.SenderItemID),
          IsReceiver: new UntypedFormControl(element?.IsReceiver),
          ReceiverItemID: new UntypedFormControl(element?.ReceiverItemID),
          IsSender: new UntypedFormControl(element?.IsSender),
          Responses: element?.Responses
            ? this.populateResponses(element.Responses)
            : null,
          Title: new UntypedFormControl(element?.Title),
          defaultTypeInfo: new UntypedFormControl(element?.defaultTypeInfo),
          maxThreshold: new UntypedFormControl(element?.maxThreshold),
          maxTypeInfo: new UntypedFormControl(element?.maxTypeInfo),
          minThreshold: new UntypedFormControl(element?.minThreshold),
          minTypeInfo: new UntypedFormControl(element?.minTypeInfo),
          property: new UntypedFormControl(element?.property),
          maxItemResponseBehaviorID: new UntypedFormControl(
            element?.maxItemResponseBehaviorID
          ),
          minItemResponseBehaviorID: new UntypedFormControl(
            element?.minItemResponseBehaviorID
          ),
          defaultItemResponseBehaviorID: new UntypedFormControl(
            element?.defaultItemResponseBehaviorID
          ),
          resValue: new UntypedFormControl('-'),
          ItemFormat:new UntypedFormControl(element?.ItemFormat ? element?.ItemFormat : null) ,
          isNotApplicable: new UntypedFormControl(null),
          displayChildItem: new UntypedFormControl(null),
          ResponseId: new UntypedFormControl(null),
          responseValueTypeID: new UntypedFormControl(element?.ResponseValueTypeID),
          isRequiredConfidential: new UntypedFormControl(element?.DefaultRequiredConfidentiality),
          isShowCard: new UntypedFormControl(true),
          isShowItemRow: new UntypedFormControl(element?.isShowItemRow ? element?.isShowItemRow : false),
          personSupportID: new UntypedFormControl(null),
          assesments: this.populateAssesmentByItemid(
            element?.ItemId,
            catObj?.catId, element?.ResponseValueTypeID
          ),
          startDate: new UntypedFormControl(element?.StartDate),
          endDate: new UntypedFormControl(element?.EndDate),
          noteText: new UntypedFormControl(null),
          showAddNote: new UntypedFormControl(false),
          showRadioButton: new UntypedFormControl(false),
          showDropDown: new UntypedFormControl(false),
          showAddNoteLink: new UntypedFormControl(true),
          caregiverCategory:
            catObj?.focusId === 2
              ? new UntypedFormControl(catObj?.catId)
              : new UntypedFormControl(null),
          supplementalDescription: new UntypedFormControl(element?.supplementalDescription ? this.getDescriptionText(element?.supplementalDescription) : null),
          considerations: new UntypedFormControl(element?.considerations ? element?.considerations : null),
          isPersonRequestedConfidential: new UntypedFormControl(element?.DefaultPersonRequestedConfidentiality),
          isOtherConfidential: new UntypedFormControl(element?.DefaultOtherConfidentiality),
          UseOtherConfidentiality: new UntypedFormControl(element?.UseOtherConfidentiality ? element?.UseOtherConfidentiality : false),
          UsePersonRequestedConfidentiality: new UntypedFormControl(element?.UsePersonRequestedConfidentiality ?
            element?.UsePersonRequestedConfidentiality : false),
          DefaultResponseID: new UntypedFormControl(element?.DefaultResponseID !== '-' ? parseInt(element?.DefaultResponseID) : element?.DefaultResponseID),
          UseRequiredConfidentiality: new UntypedFormControl(element?.UseRequiredConfidentiality ? element?.UseRequiredConfidentiality : false),
          displayMultiple: new UntypedFormControl(false),
          childItems: this.essentialsService.populateChildItems(element?.ChildItems,IsCategoryExpiry),
          isResponseRequired: catObj?.type === null ? new UntypedFormControl(IsCategoryExpiry == 0 ? element?.ResponseRequired:false) : new UntypedFormControl(element?.isResponseRequired),
          ShowNotes: new UntypedFormControl(element?.ShowNotes),
          NotesRequired: new UntypedFormControl(element?.NotesRequired)

        })
      );
    });
    return versionArray;
  }


  /**
   * populate Responses
   * @param object responses
   */
  populateResponses(responses: any) {
    let isemptyResponseAdded = false;
    const responseArray = new UntypedFormArray([]);
    responses.forEach((element) => {
      if (element.Value === '-') {
        isemptyResponseAdded = true;
      }
      const displayChildItem = (element?.displayChildItem === true || element?.DisplayChildItem) ? true : false;
      responseArray.push(
        this.formBuilder.group({
          Description: new UntypedFormControl(element.Description),
          KeyCodes: new UntypedFormControl(element.KeyCodes),
          Label: new UntypedFormControl(element.Label),
          ListOrder: new UntypedFormControl(element.ListOrder),
          ResponseId: new UntypedFormControl(element.ResponseId),
          ResponseValue: new UntypedFormControl(null),
          Value: new UntypedFormControl(element.Value),
          dropdownChar: new UntypedFormControl(element.dropdownChar),
          MaxRangeValue: new UntypedFormControl(element.MaxRangeValue),
          displayChildItem: new UntypedFormControl(displayChildItem),
          AllowMultipleGroups: new UntypedFormControl(element?.AllowMultipleGroups),
          colorPalette: element.colorPalette
            ? new UntypedFormControl(element.colorPalette)
            : null,
        })
      );
    });

    return responseArray;
  }

  /**
   * populate Assesment
   */
  populateAssesment() {
    const assessArray = new UntypedFormArray([]);
    const assessment = this.emailassessmentData.assessment;
    assessArray.push(
      this.formBuilder.group({
        assessmentID: new UntypedFormControl(assessment.assessmentID),
        assessmentResponseID: new UntypedFormControl(assessment.assessmentResponseID),
        value: new UntypedFormControl(assessment.value),
        itemId: new UntypedFormControl(assessment.itemId),
        isRequiredConfidential: new UntypedFormControl(null),
        isPersonRequestedConfidential: new UntypedFormControl(null),
        isOtherConfidential: new UntypedFormControl(null),
        note: new UntypedFormControl(null),
        showDropDown: new UntypedFormControl(false),
        ResponseId: assessment.responseId ? new UntypedFormControl(assessment.responseId) : null,
        colorPalette: assessment.colorPalette
          ? new UntypedFormControl(assessment.colorPalette)
          : null,
        isSkipped: new UntypedFormControl(false)
      })
    );
    return assessArray;
  }

  /**
   * populate Assesment By Itemid
   * @param object ItemId
   * @param object catID
   */
  populateAssesmentByItemid(ItemId: any, catID: any, responseValueTypeID: any) {
    const assessArray = new UntypedFormArray([]);
    const assessment = this.emailassessmentData.assessment;
    assessArray.push(
      this.formBuilder.group({
        assessmentID: new UntypedFormControl(assessment.assessmentID),
        assessmentResponseID: new UntypedFormControl(assessment.assessmentResponseID),
        itemResponseBehaviorID: new UntypedFormControl(
          assessment.itemResponseBehaviorID
        ),
        value: new UntypedFormControl('-', [Validators.required]),
        Label: new UntypedFormControl(assessment.Label),
        itemId: new UntypedFormControl(ItemId),
        isRequiredConfidential: new UntypedFormControl(
          assessment.isRequiredConfidential
            ? assessment.isRequiredConfidential
            : false
        ),
        isPersonRequestedConfidential: new UntypedFormControl(
          assessment.isPersonRequestedConfidential
            ? assessment.isPersonRequestedConfidential
            : false
        ),
        isOtherConfidential: new UntypedFormControl(
          assessment.isOtherConfidential
            ? assessment.isOtherConfidential
            : false
        ),
        personSupportID: new UntypedFormControl(assessment.personSupportID),
        note: new UntypedFormArray([]),
        showDropDown: new UntypedFormControl(true),
        keyCodes: new UntypedFormControl(assessment.keyCodes),
        date: new UntypedFormControl(assessment.dateTaken),
        catID: new UntypedFormControl(catID),
        ResponseId: responseValueTypeID == this.scoreResponseListType ? new UntypedFormControl({value : assessment?.responseId, disabled: true})
        : assessment.responseId ? new UntypedFormControl(assessment.responseId) : '-',
        colorPalette: assessment.colorPalette
          ? new UntypedFormControl(assessment.colorPalette)
          : null,
        isSkipped: new UntypedFormControl(false),
        files: assessment?.files
                  ? this.populateFiles(assessment?.files)
                  : new UntypedFormArray([]),
      })
    );
    this.DisablePastAndFutureSupport();
    return assessArray;
  }

  /**
   * show Card
   * @param object isShowCard
   */
  showCard(isShowCard: any) {
    isShowCard.setValue(!isShowCard.value);
  }

  /**
   * category ShowHide
   * @param object showDetails
   */
  categoryShowHide(showDetails: any, category?: any) {
    if (
      !category.showSupportDropDown.value ||
      category.supportID.value !== null
    ) {
      showDetails.setValue(!showDetails.value);
      if (showDetails.value) {
        // Collapsing inner items
        category['versionItems'].controls.forEach((versionItem) => {
          versionItem['controls'].isShowCard.setValue(this.toggleExpansionFlag);
        });
      }
    }
  }

  /**
   * select Question
   * @param number catIndex
   * @param number verIndex
   */
  selectQuestion(catIndex: any, verIndex: any) {
    this.enableHighlight = true;
    this.currentQuestionIndex = verIndex;
    this.currentCategoryIndex = catIndex;
  }

  // ....................... Handle Qs response change ..............................//

  /**
   * On key press of QS Assessment dropdown
   * @param event tevent
   * @param object versionItem
   * @param object category
   * @param object dropDownElement
   * @param number catIndex
   * @param number verIndex
   */
  onKeyPressed(
    event: KeyboardEvent,
    versionItem: any,
    category: any,
    dropDownElement: any,
    catIndex: any,
    verIndex: any
) {
    this.currentQuestionIndex = verIndex;
    this.currentCategoryIndex = catIndex;
    const response = versionItem?.Responses as UntypedFormArray;
    let responseKeyCodes = [];
    const responseValue = {};
    response?.getRawValue()?.forEach((res) => {
        if (res.KeyCodes) {
            const keyCodes = res.KeyCodes.split('|');
        responseKeyCodes = responseKeyCodes.concat(keyCodes);
            keyCodes.forEach((code) => {
                responseValue[code] = res;
            });
        }
    });

    const data = responseKeyCodes.find(
      (res) => res.toLowerCase() === event.key.toLowerCase()
    );

    if (data) {
      // Prevent the keycode from propagating to other elements (like textareas)
      event.preventDefault();
      event.stopPropagation();

      dropDownElement.value = responseValue[data].ResponseId;
        const assesmentArray = versionItem?.assesments as UntypedFormArray;
      assesmentArray?.at(0)?.get('ResponseId')?.setValue(responseValue[data].ResponseId);
      assesmentArray?.at(0)?.get('value')?.setValue(responseValue[data].Value);
      versionItem?.resValue?.setValue(responseValue[data].Value);
        let itemResponseBehaviorID = null;
      if (responseValue[data].ListOrder <= versionItem?.minThreshold?.value) {
        itemResponseBehaviorID = versionItem?.minItemResponseBehaviorID?.value;
      } else if (responseValue[data].ListOrder >= versionItem?.maxThreshold?.value) {
        itemResponseBehaviorID = versionItem?.maxItemResponseBehaviorID?.value;
      } else if (responseValue[data].ListOrder === '-') {
        itemResponseBehaviorID = null;
      } else {
        itemResponseBehaviorID =
          versionItem?.defaultItemResponseBehaviorID?.value;
        }
      assesmentArray
        ?.at(0)
        ?.get('itemResponseBehaviorID')
        ?.setValue(itemResponseBehaviorID);
        this.findAssesmentSummation();
        this.setResponseValueFromResponseId(catIndex, verIndex);
        this.moveOnToNextDropdown(dropDownElement, category, versionItem);
    }
}
tabPressed(event: KeyboardEvent,
  versionItem: any,
  category: any,
  catIndex: any,
  verIndex: any){
  if (event.key === 'Tab') {
    this.currentQuestionIndex = verIndex;
    this.currentCategoryIndex = catIndex;
    event.preventDefault();
    this.moveOnToNextDropdown(null, category, versionItem);
  }
}
  /**
    * To find the next category that should be displayed. Where the isHidden value is false
    * @param  any catIndex
    */
  findNextCategory(catIndex: any) {
    let findNextCategoryFlag = false;
    for (let c = catIndex + 1; c < this.questionCategories.getRawValue().length; c++) {
        const category = this.questionCategories.getRawValue()[c];
        if (category?.IsCategoryExpiry !== 0) {
            continue;
        }
        findNextCategoryFlag = false;
        category.versionItems.forEach(version => {
            version.assesments.forEach(assessment => {
                if (
                    assessment.showDropDown === true &&
                    (!category.showSupportDropDown || category.supportID != null)
                ) {
                    findNextCategoryFlag = true;
                }
            });
        });

        if (findNextCategoryFlag) {
            return c;
        }
    }
    return catIndex;
}

  /**
    * Move to next dropdown after on key press
    * @param object dropDownElement
    * @param object category
    */

  moveOnToNextDropdown(dropDownElement: any, category: any, versionItem: any) {
    this.skipQuestions();
    this.setScoringLogic();
    let noOfDropdownMove = 0;
    if(dropDownElement){
      dropDownElement.close();
    }
    const versionArray = category?.versionItems as UntypedFormArray;
    const filteredVersionItems = versionArray?.value?.filter((val) => val.showRadioButton === false || val.showDropDown === true);
    const questionIndexArray = filteredVersionItems
        .flatMap(filterVersion =>
            filterVersion.assesments
                .filter(assesment => assesment.showDropDown)
                .map(() => versionArray?.value.findIndex((val) => val.ItemId === filterVersion.ItemId))
        );

    const Qindex = questionIndexArray.indexOf(this.currentQuestionIndex);
    this.currentQuestionIndex = questionIndexArray[Qindex + 1];

    if (versionItem?.ItemId?.value === filteredVersionItems[filteredVersionItems.length - 1].ItemId) {
        this.currentCategoryIndex = this.findNextCategory(this.currentCategoryIndex);
        const nextCategory = this.questionCategories.at(this.currentCategoryIndex);
        const nextVersionArray = nextCategory?.get('versionItems') as UntypedFormArray;

        if (nextVersionArray) {
            const questionCategoryIndexArray = nextVersionArray.value
                .filter(val => !val.showRadioButton)
                .flatMap(filterVersion =>
                    filterVersion.assesments
                        .filter(assesment => assesment.showDropDown)
                        .map(() => nextVersionArray?.value.findIndex(val => val.ItemId === filterVersion.ItemId))
                );
            if (nextCategory?.value.showSupportDropDown && nextCategory.value.supportID === null) {
                noOfDropdownMove = 2;
            }

            const showNextCategory = nextCategory?.get('showCategory') as UntypedFormControl;
            if (showNextCategory) {
                showNextCategory.setValue(true);
                this.currentQuestionIndex = questionCategoryIndexArray[0];
            }
    }
  }
    const assesmentArray = versionArray.at(this.currentQuestionIndex).get('assesments') as UntypedFormArray;
    const index = assesmentArray?.getRawValue()?.findIndex((val) => val.assessmentID === this.assesmentNumber);
    if(index !== -1){
    const currentValue = assesmentArray?.at(index)?.get('value').value;
    const currentResValue = versionArray.at(this.currentQuestionIndex)?.get('resValue').value;
    if (currentValue === '-') {
        assesmentArray.at(index).get('value').setValue(null);
    }
    if (currentResValue === '-') {
        versionArray.at(this.currentQuestionIndex)?.get('resValue').setValue(null);
    }
    }
    const nextDropdown = document.getElementById(
        'mat-select-' + this.currentCategoryIndex + '-' + this.currentQuestionIndex
    );
    setTimeout(() => {
        nextDropdown?.focus();
    }, 150);
}


  /**
   * set Qs Response on radio button
   * @param event event
   * @param object versionItem
   */
  setQsResponse(event: any, versionItem: any, i, j) {
    this.setInviteToCompleteValueChange(true);
    const versionArray = this.questionCategories.at(i).get('versionItems') as UntypedFormArray;
    const responseArray = versionItem?.Responses as UntypedFormArray;
    const assesArray = versionItem?.assesments as UntypedFormArray;
    const index = assesArray?.getRawValue()?.findIndex((val) => val.assessmentID === this.assesmentNumber);
    let responseObject = responseArray.getRawValue().find((val) => val.ResponseId === event.value);
    if (!responseObject) {
      responseObject = responseArray.getRawValue().find(val => val.Value !== '-');
    }

    if (!responseObject?.displayChildItem) {
      assesArray.at(index)?.get('childItemResponses')?.setValue('');
      if(this.signatureArray && this.signatureArray.length>0){
        let versionItemSignatureList :any = this.signatureArray.filter((val) => val.index === j && val.category === i  && val.isChildItem === true);
        if(versionItemSignatureList && versionItemSignatureList.length>0){
          versionItemSignatureList.forEach(element => {
        let signatureIndex = this.signatureArray.findIndex((val) => val.index === element.index && val.category === element.category && val.group === element.group && val.groupItem == element.groupItem && val.isChildItem === element.isChildItem);
        if (signatureIndex > -1) this.signatureArray.splice(signatureIndex, 1);
          });
        }
      }
    }
    assesArray.at(0).get('ResponseId').setValue(event.value);
    assesArray.at(0).get('value')?.setValue(responseObject?.Value);
    versionArray.at(j).get('displayChildItem').setValue(responseObject?.displayChildItem);
    versionArray.at(j).get('ResponseId')?.setValue(responseObject?.ResponseId);
    versionArray.at(j).get('displayMultiple').setValue(responseObject?.AllowMultipleGroups);
    let itemResponseBehaviorID = null;
    const assessmentValue = assesArray.at(0).get('value')?.value;
    if (versionItem?.responseValueTypeID === this.responseSliderType) {
      if (assessmentValue <= versionItem?.lowerResponseValue) {
        itemResponseBehaviorID = versionItem?.minItemResponseBehaviorID;
      } else if (assessmentValue >= versionItem?.upperResponseValue) {
        itemResponseBehaviorID = versionItem?.maxItemResponseBehaviorID;
      } else {
        itemResponseBehaviorID = versionItem?.defaultItemResponseBehaviorID;
      }
    } else {
      if (responseObject?.Value === '-') {
        itemResponseBehaviorID = null;
      } else if (responseObject?.ListOrder <= versionItem?.minThreshold?.value) {
        itemResponseBehaviorID = versionItem?.minItemResponseBehaviorID?.value;
      } else if (responseObject?.ListOrder >= versionItem?.maxThreshold?.value) {
        itemResponseBehaviorID = versionItem?.maxItemResponseBehaviorID?.value;
      } else {
        itemResponseBehaviorID = versionItem?.defaultItemResponseBehaviorID?.value;
      }
    }
    assesArray.at(0).get('itemResponseBehaviorID').setValue(itemResponseBehaviorID);
    this.findAssesmentSummation();
    this.skipQuestions();
    this.setScoringLogic();
  }

  /**
   * on Qs SelectChange set assesment values
   * @param event event
   * @param object versionItem
   */
  onQsSelectChange(event: any, versionItem: any) {
    const assesmentArray = versionItem?.assesments as UntypedFormArray;
    versionItem?.resValue?.setValue(event.value);
    const responseArray = versionItem?.Responses as UntypedFormArray;
    const IsResponseIdAvailable = versionItem?.IsResponseIdAvailable?.value;
    let responseObject;
    if (IsResponseIdAvailable) {
      const responseID = assesmentArray.at(0).get('ResponseId').value;
      responseObject = responseArray.getRawValue().find((val) => val.ResponseId === responseID);
    } else {
      const responseValue = assesmentArray.at(0).get('value').value;
      responseObject = responseArray.getRawValue().find((val) => val?.Value === responseValue);
    }
    assesmentArray.at(0).get('value')?.setValue(responseObject?.Value);
    let itemResponseBehaviorID = null;
    if (responseObject?.Value === '-') {
      itemResponseBehaviorID = null;
    } else if (responseObject?.ListOrder <= versionItem?.minThreshold?.value) {
      itemResponseBehaviorID = versionItem?.minItemResponseBehaviorID?.value;
    } else if (responseObject?.ListOrder >= versionItem?.maxThreshold?.value) {
      itemResponseBehaviorID = versionItem?.maxItemResponseBehaviorID?.value;
    } else {
      itemResponseBehaviorID = versionItem?.defaultItemResponseBehaviorID?.value;
    }
    assesmentArray.at(0).get('itemResponseBehaviorID').setValue(itemResponseBehaviorID);
    this.findAssesmentSummation();
  }

  /**
   *
   * @param event event set mark as Confidential
   * @param object versionItem
   */
  setConfidential(event: any, versionItem: any, i: any, j: any, type: any) {
    const versionArray = this.questionCategories.at(i).get('versionItems') as UntypedFormArray;
    const assesmentArray = versionItem?.assesments as UntypedFormArray;
    if (type === localStorageConstants.requiredConfidentialityLanguage) {
      versionArray.at(j).get('isRequiredConfidential')?.setValue(event.value);
      assesmentArray.at(0).get('isRequiredConfidential').setValue(event.value);
    } else if (type === localStorageConstants.personRequestedConfidentialityLanguage) {
      versionArray.at(j).get('isPersonRequestedConfidential')?.setValue(event.value);
      assesmentArray.at(0).get('isPersonRequestedConfidential').setValue(event.value);
    } else {
      versionArray.at(j).get('isOtherConfidential')?.setValue(event.value);
      assesmentArray.at(0).get('isOtherConfidential').setValue(event.value);
    }
    this.setInviteToCompleteValueChange(true);
  }

  /**
   * get Response label in html
   * @param object response
   */
  getResponselabel(response: any) {
    return response.KeyCodes?.value + '=' + response.Label?.value;
  }

  /**
   * get Label From Value
   * @param string assessmentValue
   * @param object response
   */
  getLabelFromValue(assessmentValue: any, response: any) {
    let label = '';
    response?.forEach((res) => {
      if (res?.value.Value === assessmentValue) {
        label = res?.value.Label;
      } else if (assessmentValue === '-') {
        label = '-';
      }
    });
    return label;
  }

  // ....................... End of Handle Qs response change ......................//
  // ........................ Notes handling .......................................//

  addNote(versionItem: any) {
    const assesmentArray = versionItem?.assesments as UntypedFormArray;
    const noteArray = assesmentArray?.at(0)?.get('note') as UntypedFormArray;
    const isAnyEdit = noteArray?.controls?.some(ctrl => ctrl.get('isEdit')?.value === true);

  if (isAnyEdit) {
      // If any note is in edit mode, focus on the edit textarea instead of opening add note
      this.noteEditInput?.nativeElement?.focus();
      return;
    }

    // Open add note interface - user can then click on the textarea to focus
    versionItem?.showAddNote?.setValue(true);
  }

  /**
   * set Notes
   */
  setNotes(versionItem: any, type?: any, noteIndex?: any) {
    versionItem?.noteText?.setValidators([Validators.required, ValidateWhiteSpace]);
    versionItem?.noteText?.updateValueAndValidity();
    if (versionItem?.noteText?.valid) {
      const assesmentArray = versionItem?.assesments as UntypedFormArray;
      const notesArray = assesmentArray?.at(0)?.get('note') as UntypedFormArray;
      if (type === 'edit') {
        versionItem?.showAddNoteLink?.setValue(true);
        notesArray
          ?.at(noteIndex)
          ?.get('noteText')
          ?.setValue(versionItem?.noteText?.value);
        notesArray?.at(noteIndex)?.get('isEdit')?.setValue(false);
        versionItem?.noteText?.setValue(null);
      } else {
        notesArray.push(
          this.formBuilder.group({
            Author: new UntypedFormControl(''),
            NoteId: new UntypedFormControl(0),
            noteText: new UntypedFormControl(versionItem?.noteText?.value),
            isEdit: new UntypedFormControl(false),
          })
        );
        versionItem?.noteText?.setValue(null);
        versionItem?.showAddNote?.setValue(false);
      }
      versionItem?.noteText?.setValidators(null);
      versionItem?.noteText?.updateValueAndValidity();
    } else {
      versionItem?.noteText?.markAllAsTouched();
    }
  }

  /**
   * Close all open notes in edit mode
   * @param versionItem
   */
  closeAllOpenNotes(versionItem: any) {
    const assesmentArray = versionItem?.assesments as UntypedFormArray;
    const noteArray = assesmentArray?.at(0)?.get('note') as UntypedFormArray;
    // Check if any note is currently in edit mode
    noteArray?.getRawValue()?.forEach((note, index) => {
      if (note.isEdit) {
        noteArray?.at(index)?.get('isEdit')?.setValue(false);
      }
    });
    // Close the add new note interface
    versionItem?.showAddNote?.setValue(false);
    versionItem?.showAddNoteLink?.setValue(true);
    // Clear the noteText field
    versionItem?.noteText?.setValue(null);
  }

  deleteItemPopUp(versionItem: any, noteIndex :any) {
    // Close all open notes before showing delete confirmation
    this.closeAllOpenNotes(versionItem);

    this.conformMessage = localStorageConstants?.confirmationMessage;
    this.modalEvent = {
      event: 'deleteItemnote',
      versionItem : versionItem,
      noteIndex: noteIndex
    };
    this.confirmDialog.openModal();
  }


  /**
   * delete Note
   * @param object versionItem
   * @param number noteIndex
   */
  deleteNote(versionItem: any, noteIndex: any) {
    const assesmentArray = versionItem?.assesments as UntypedFormArray;
    const noteArray = assesmentArray?.at(0)?.get('note') as UntypedFormArray;
    noteArray?.removeAt(noteIndex);
    versionItem?.noteText?.setValue(null);
  }

  /**
   * get Notes
   * @param object versionItem
   */
  getNotes(versionItem: any) {
    const assesmentArray = versionItem?.assesments as UntypedFormArray;
    return assesmentArray?.at(0)?.get('note') as UntypedFormArray;
  }

  /**
   * Function to get the notes added
   * @param versionItem VersionItem form array
   */
  getNotesLength(versionItem: any) {
    const assesmentArray = versionItem?.assesments as UntypedFormArray;
    const notesArray = assesmentArray?.at(0)?.get('note') as UntypedFormArray;
    return notesArray?.getRawValue()?.length || 0;
  }

  /**
   * clear Notes
   * @param object versionItem
   * @param number noteIndex
   */
  clearNotes(versionItem: any, noteIndex?: any) {
    versionItem?.noteText?.setValue(null);
    // Hide the add note textbox similar to regular assessment behavior
    versionItem?.showAddNote?.setValue(false);
    // Remove validators when hiding the textbox
    versionItem?.noteText?.setValidators(null);
    versionItem?.noteText?.updateValueAndValidity();

    if (noteIndex != null) {
      versionItem?.showAddNoteLink?.setValue(true);
      const assesmentArray = versionItem?.assesments as UntypedFormArray;
      const notesArray = assesmentArray.at(0).get('note') as UntypedFormArray;
      notesArray.at(noteIndex).get('isEdit').setValue(false);
    }
  }

  /**
   * edit Note
   * @param object versionItem
   * @param number noteIndex
   */
  editNote(versionItem: any, noteIndex: any) {
    const assesmentArray = versionItem?.assesments as UntypedFormArray;
    const noteArray = assesmentArray?.at(0)?.get('note') as UntypedFormArray;
    // Check if add note is open
    if (versionItem?.showAddNote?.value === true) {
      this.noteInput?.nativeElement?.focus();
      return;
    }
    // Check if any note is already in edit mode
    const isAnyEdit = noteArray?.controls?.some(ctrl => ctrl.get('isEdit')?.value === true);
    if (isAnyEdit) {
      // If another note is being edited, focus on the current edit textarea
      this.noteEditInput?.nativeElement?.focus();
      return;
    }

    // Clear and start editing the selected note
    versionItem?.noteText?.setValue(null);
    noteArray?.getRawValue()?.forEach((note, index) => {
      noteArray?.at(index)?.get('isEdit')?.setValue(false);
    });
    versionItem?.noteText?.setValue(
      noteArray?.at(noteIndex)?.get('noteText')?.value
    );
    noteArray?.at(noteIndex)?.get('isEdit')?.setValue(true);
  }

  // ........................ End of Notes handling .......................................//

  findAssesmentSummation() {
    const assessmentvalues = this.questionCategories.value;
    const assLen = assessmentvalues ? assessmentvalues.length : 0;
    for (let i = 0; i < assLen; i++) {
      const originalArray = [];
      assessmentvalues[i].versionItems.forEach(version => {
        if ((version.showRadioButton !== true || version.showDropDown === true)
          && version.isResponseRequired && !version.isHiddenQuestion) {
          originalArray.push(version);
        }
      });
      this.attendquestioncount[i] = 0;
      let sum = 0;
      this.percentages = 0;
      this.progressBarColor = null;
      this.versionitemdatacount[i] = originalArray.length;
      const versionItems = originalArray;
      const versionLen = originalArray.length;
      const originalChildArray = [];
      this.ischildItemSelected = false;
      this.skippedQuestionsCount = 0;
      for (let j = 0; j < versionLen; j++) {
        if (versionItems[j].responseValueTypeID !== 5 && versionItems[j].responseValueTypeID !== 12) {
          if (!versionItems[j].assesments[0].isSkipped) {
            if (versionItems[j].assesments[0].value != null && versionItems[j].assesments[0].value !== '-' && versionItems[j].assesments[0].value !== '') {
              this.attendquestioncount[i]++;
            }
          } else {
            this.skippedQuestionsCount += 1;
          }

          this.percentages = Math.round(
            (this.attendquestioncount[i] / (this.versionitemdatacount[i] - this.skippedQuestionsCount)) * 100);

          this.questionCategories.at(i).get('percentage').setValue(this.percentages);
          if (this.percentages > 0 && this.percentages < 50) {
            this.progressBarColor = 'Orange';
          }
          if (this.percentages >= 50 && this.percentages < 74) {
            this.progressBarColor = 'Reef';
          }
          if (this.percentages >= 75 && this.percentages < 100) {
            this.progressBarColor = 'Granny';
          }
          if (this.percentages === 100) {
            this.progressBarColor = 'Green';
          } else {
            this.percentages = null;
          }
          this.questionCategories.at(i).get('progressBarColor').setValue(this.progressBarColor);
        }
      }

      for (let j = 0; j < assessmentvalues[i]?.versionItems?.length; j++) {
        if (assessmentvalues[i]?.versionItems[j]?.responseValueTypeID !== 5 && assessmentvalues[i]?.versionItems[j]?.responseValueTypeID !== 12) {
          if (!assessmentvalues[i]?.versionItems[j]?.assesments[0]?.isSkipped) {
            if (assessmentvalues[i]?.versionItems[j]?.assesments[0]?.value != null && assessmentvalues[i]?.versionItems[j]?.assesments[0]?.value !== '-' && assessmentvalues[i]?.versionItems[j]?.assesments[0]?.value !== '') {
              if(assessmentvalues[i]?.versionItems[j]?.responseValueTypeID === this.responseListType) {
                sum = sum + assessmentvalues[i]?.versionItems[j]?.assesments[0]?.value;
              }
              if(assessmentvalues[i]?.versionItems[j]?.responseValueTypeID === this.responseSliderType) {
                sum = sum + assessmentvalues[i]?.versionItems[j]?.assesments[0]?.value;
              }
            }
          }
          this.SummationArray[j] = sum;
          this.questionCategories.at(i).get('summation').setValue(sum);
        }
      }
    }
  }

  // ........................care giver support handling ..................................//

  /**
   * select SupportName
   * @param number catIndex
   */
  selectSupportName(catIndex: any) {
    this.setDefaultResponses(true, catIndex);
    const showNextCategory = this.questionCategories
      .at(catIndex)
      ?.get('showCategory') as UntypedFormControl;
    showNextCategory?.setValue(true);
    if (showNextCategory) {
      this.currentCategoryIndex = this.currentCategoryIndex + 1;
      this.currentQuestionIndex = 0;
    }
    this.validQuestionEndDate();
  }

  /**
   * add Suporter
   * @param object category
   * @param number catIndex
   */
  addSuporter(category: any, catIndex: any) {
    let caregivertab;
    this.noOfCareGiversAdded = this.noOfCareGiversAdded + 1;
    this.personSupports.forEach((support) => {
      if (category.supportID.value === support.personSupportID) {
        support.isDisable = true;
      }
    });
    const versionItems = category.versionItems;
    let newVersionArray = versionItems?.getRawValue();
    const version = this.categories[catIndex].VersionItems;
    newVersionArray?.forEach((element, i) => {
      newVersionArray[i].ResponseValueTypeID = element?.responseValueTypeID;
      newVersionArray[i].ChildItems = version[i]?.ChildItems;
    });
    category.showCategory.setValue(false);
    category.supportID.disable();
    const caregiverCategories = this.questionCategories
      .getRawValue()
      .filter((val) => val.FocusId === 2);
    let categoryId =
      '' +
      this.questionCategories.at(catIndex).get('CategoryId').value +
      (caregiverCategories.length + 1);
    if (
      this.questionCategories
        .getRawValue()
        .find((val) => val.CategoryId === parseInt(categoryId, 10))
    ) {
      categoryId = categoryId + new Date().getTime();
    }
    let isDisabledCategoryValue=this.questionCategories.at(catIndex).get('isDisabledCategory') && this.questionCategories.at(catIndex).get('isDisabledCategory').value ? this.questionCategories.at(catIndex).get('isDisabledCategory').value:false;
    let isHiddenCategoryValue= this.questionCategories.at(catIndex).get('isHiddenCategory') && this.questionCategories.at(catIndex).get('isHiddenCategory').value ? this.questionCategories.at(catIndex).get('isHiddenCategory').value :false;
    this.questionCategories.insert(
      catIndex + 1,
      this.formBuilder.group({
        CategoryName: new UntypedFormControl(category.CategoryName.value),
        CategoryId: new UntypedFormControl(parseInt(categoryId, 10)),
        FocusId: new UntypedFormControl(2),
        CategoryDescription: new UntypedFormControl(category.CategoryDescription.value),
        versionItems: this.populateVersionItems(newVersionArray, {
          catId: parseInt(categoryId, 10),
          focusId: 2,
          type: 'support'
        }),
        caregiverName: new UntypedFormControl(null),
        personSupportID: new UntypedFormControl(null),
        assesmentValues: this.populateAssesment(),
        summation: new UntypedFormControl(0),
        percentage: new UntypedFormControl(0),
        progressBarColor: new UntypedFormControl(null),
        showCategory: new UntypedFormControl(false),
        showSupportDropDown: new UntypedFormControl(true),
        supportID: new UntypedFormControl(null, [Validators.required]),
        skippedCategory: new UntypedFormControl(false),
        isDisabledCategory: new UntypedFormControl(
          isDisabledCategoryValue
        ),
        isHiddenCategory: new UntypedFormControl(
          isHiddenCategoryValue
        ),
      })
    );
    this.DisablePastAndFutureSupport();
    caregivertab = document.getElementById(
      'caregivertab'
    );
    setTimeout(() => {
      caregivertab?.focus();
    })

  }

  /**
   * check Supports to show or not on UI
   * @param object category
   */
  checkSupports(category: any) {
    if (this.personSupports.length > 0) {
      const availablesupports = this.personSupports.filter(
        (val) => val.isDisable !== true
      );
      if (availablesupports.length > 1) {
        const isCategoryValid = category.supportID.status;
        if (isCategoryValid === 'DISABLED') {
          return false;
        }
        return true;
      }
      return false;
    }
    return false;
  }

  /**
   * Remove supporter
   * @param number catIndex
   */
  removeSupporter(catIndex: any) {
    this.conformMessage = localStorageConstants.confirmDelete;
    this.modalEvent = {
      event: 'caregiver',
      index: catIndex,
    };
    // this.confirmDialog.openModal();
    this.modalResponse = 'caregiver';
    this.message = 'Are you sure you want to delete?';
    this.btnText = 'Delete';
    this.openModal();
  }

  /**
   *
   * @param value Handle Confirm dialog events
   */
  getModalEvent(value: any) {
    if (value) {
      switch (this.modalEvent.event) {
        case 'caregiver':
          this.clearCareGiverValues(this.modalEvent.index);
          break;
        case 'submitAssessment':
          this.submitAssessment();
          break;
        case 'deleteItemnote':
          this.deleteNote(this.modalEvent.versionItem,this.modalEvent.noteIndex)
      }
    }
  }

  /**
   * clear Care Giver Values
   * @param number catIndex
   */
  clearCareGiverValues(catIndex: any) {
    const supportID = this.questionCategories.at(catIndex).get('supportID')
      .value;
    const careGivers = [];
    let previousSupportId;
    this.questionCategories.getRawValue().forEach((questions) => {
      if (questions.FocusId === 2) {
        careGivers.push(questions.supportID);
      }
    });
    if (
      this.questionCategories.at(catIndex - 1) &&
      this.questionCategories.at(catIndex - 1).get('FocusId').value === 2
    ) {
      const index = careGivers.indexOf(supportID);
      if (!careGivers[index + 1]) {
        this.questionCategories
          .at(catIndex - 1)
          .get('showCategory')
          .setValue(true);
        this.questionCategories
          .at(catIndex - 1)
          .get('supportID')
          .enable();
        previousSupportId = this.questionCategories
          .at(catIndex - 1)
          .get('supportID').value;
      }
    }
    const careGiversLen = careGivers.length;
    this.personSupports.forEach((support) => {
      if (
        careGiversLen <= 2 ||
        supportID === support.personSupportID ||
        previousSupportId === support.personSupportID
      ) {
        support.isDisable = false;
      }
    });

    if (this.noOfCareGiversAdded > 1) {
      this.noOfCareGiversAdded = this.noOfCareGiversAdded - 1;
      this.questionCategories.removeAt(catIndex);
    } else {
      const category = this.questionCategories.at(catIndex);
      category.get('showCategory').setValue(false);
      category.get('supportID').setValue(null);
      const versionItems = category.get('versionItems') as UntypedFormArray;
      versionItems.controls.forEach((version) => {
        const versionItem = version['controls'];
        const assesmentArray = versionItem?.assesments as UntypedFormArray;
        assesmentArray?.at(0)?.get('value')?.setValue(null);
        versionItem?.resValue?.setValue(null);
      });
      this.findAssesmentSummation();
      this.validQuestionEndDate();
    }
  }

  // ........................End of care giver support handling ...................................//
  // ........................ Submit assessment.....................................................//
  /**
   * Submit assessment to the server
   * Handles different response status codes and manages consent approval for anonymous questionnaires
   */
  submitAssessment(): void {
    if (!this.isFormValid) return;

    this.isRequestSubmitted = true;
    this.disableFormAfterSubmit();

    this.emailAssessment.saveAssessment(this.finalAssessmentData).subscribe(
      (response) => {
        this.setInviteToCompleteValueChange(false);

        if (!response?.Data) return;

        const { assessmentID, responseStatusCode, responseStatus } = response.Data;

        // Handle assessment already submitted (status code 1013)
        if (assessmentID !== null && responseStatusCode === 1013) {
          this.errorMessage = localStorageConstants.assessmentSubmitted;
          this.isRequestInvalid = true;
        }
        // Handle assessment submitted with consent requirement (status code 1015)
        else if (assessmentID !== null && responseStatusCode === 1015) {
          this.errorMessage = localStorageConstants.assessmentSubmitted;
          this.isRequestInvalid = true;
          if (this.isFromAdvancedSearch && !this.isConsent) {
            this.addConsentApproveForQuestionnaireAnonymous({
              personIndex: this.finalAssessmentData.assessmentProgressData[0].personIndex,
              assessmentID,
              agencyId: this.agencyID,
              instrumentID: this.instrumentID
            });
          }
        }
        // Handle email assessment error (status code 1031)
        else if (responseStatusCode === 1031) {
          this.errorMessage = localStorageConstants.errorEmailAssessment;
          this.isRequestInvalid = true;
        }
        // Handle custom error message (status code 1049)
        else if (responseStatusCode === 1401) {
          this.translatorService.get(responseStatus).subscribe((translatedText) => {
            this.toastr.error(translatedText, '', { positionClass: 'toast-bottom-right' });
          });
          this.isRequestSubmitted = false;
        }
      },
      (error) => {
        console.error('Assessment submission failed:', error);
      }
    );
  }

  addConsentApproveForQuestionnaireAnonymous(params) {
    this.qService.addConsentApproveForQuestionnaireAnonymous(params).subscribe(
      (output: any) => {
        if (output.StatusCode !== 200) {
          this.message = output.Message;
          this.toastMessage(this.message);
        }
      },
      (err) => {
        this.message = err.Message;
      }
    );
  }

  /**
   * format Assessments For Saving
   */
  transformAssessmentsForSaving() {
    const assesmentResponses = [];
    const assesmetFinalList = [];
    const initialAssessmentDetails = this.emailassessmentData.assessment;
    let assessmentObj;
    var asesmentStatus = localStorageConstants?.inviteToCompletSubmitFlag;
    if (initialAssessmentDetails.voiceTypeID === 3 || initialAssessmentDetails.voiceTypeID === 4) {
      assessmentObj = {
        AssessmentVersion: initialAssessmentDetails?.assessmentVersion,
        assessmentID: initialAssessmentDetails.assessmentID,
        personIndex: this.emailassessmentData.personIndex,
        questionnaireID: this.emailassessmentData.questionnaireID,
        voiceTypeID: initialAssessmentDetails.voiceTypeID,
        voiceTypeFKID: this.emailassessmentData?.assessment?.voiceTypeFKID,
        dateTaken: initialAssessmentDetails.dateTaken,
        reasoningText: initialAssessmentDetails.reasoningText,
        assessmentReasonID: initialAssessmentDetails.assessmentReasonID,
        assessmentStatus: asesmentStatus,
        closeDate: initialAssessmentDetails.closeDate,
        eventDate: initialAssessmentDetails.eventDate,
        eventNotes: initialAssessmentDetails.eventNotes,
      };
    } else {
      assessmentObj = {
        AssessmentVersion: initialAssessmentDetails?.assessmentVersion,
        assessmentID: initialAssessmentDetails.assessmentID,
        personIndex: this.emailassessmentData.personIndex,
        questionnaireID: this.emailassessmentData.questionnaireID,
        voiceTypeID: initialAssessmentDetails.voiceTypeID,
        dateTaken: initialAssessmentDetails.dateTaken,
        reasoningText: initialAssessmentDetails.reasoningText,
        assessmentReasonID: initialAssessmentDetails.assessmentReasonID,
        assessmentStatus: asesmentStatus,
        closeDate: initialAssessmentDetails.closeDate,
        eventDate: initialAssessmentDetails.eventDate,
        eventNotes: initialAssessmentDetails.eventNotes,
      };
    }
    this.questionCategories.getRawValue().forEach((category, categoryIndex) => {
      category.versionItems.forEach((version, versionIndex) => {
        const responseArray = version.Responses;
        const assesmentArray = version.assesments;
        assesmentArray.forEach((data) => {
          const response = responseArray.find(
            (val) => val.Value === data.value
          );
          let signatureImage = null;
          let responseIdForSignature = null;
          if (version.responseValueTypeID === this.responseSignatureType || version.responseValueTypeID === this.responseDoodleType) {
            signatureImage = this.signatureArray?.find(
              (val) => val.index === versionIndex && val.category === categoryIndex
            );
            responseIdForSignature = this.setResponseIdForSignatureandDoodle(categoryIndex, versionIndex)
          }
          const assesmentResponseObj = {
            assessmentResponseID: data.assessmentResponseID,
            personSupportID:
              category.supportID === 0 ? null : category.supportID,
            responseID: data.ResponseId > 0 ? data.ResponseId : responseIdForSignature && (version.responseValueTypeID === this.responseSignatureType || version.responseValueTypeID === this.responseDoodleType) ? responseIdForSignature : null,
            isRequiredConfidential: data.isRequiredConfidential ? data.isRequiredConfidential : false,
            isPersonRequestedConfidential: data.isPersonRequestedConfidential ? data.isPersonRequestedConfidential : false,
            isOtherConfidential: data.isOtherConfidential ? data.isOtherConfidential : false,
            questionnaireItemID: version.QuestionnaireItemID,
            itemResponseBehaviorID: data.itemResponseBehaviorID
              ? data.itemResponseBehaviorID
              : version.defaultItemResponseBehaviorID,
            isCloned: false,

            caregiverCategory: version?.caregiverCategory
              ? '' + version.caregiverCategory
              : null,
            assessmentResponseNotes: data?.note ? data?.note : [],
            Value: (data?.value)?.toString(),
            assessmentResponseFiles: data.files
                ? this.getAssessmentFiles(data.files)
                : [],
            assessmentResponseChildItems: this.getChildResponses(version?.childItems, data.assessmentResponseID),
            imageValue: (version.responseValueTypeID === this.responseSignatureType || version.responseValueTypeID === this.responseDoodleType) && signatureImage ? signatureImage?.image : '',
            responseValueTypeId: version.responseValueTypeID,
          };
          //  if (!version.IsResponseIdAvailable || assesmentResponseObj.responseID) {
          assesmentResponses.push(assesmentResponseObj);
          //  }
        });
      });
    });

    assessmentObj['assessmentResponses'] = assesmentResponses;
    assesmetFinalList.push(assessmentObj);
    const AssessmentData = {
      assessmentProgressData: assesmetFinalList,
      updateUserID: this.emailassessmentData.updateUserID,
    };
    return AssessmentData;
  }

  /**
   * disable Form After Submit
   */
  disableFormAfterSubmit() {
    this.questionCategories.controls.forEach((category) => {
      category['controls'].supportID.disable();
      const versionItems = category['controls'].versionItems as UntypedFormArray;
      versionItems.controls.forEach((version) => {
        const versionItem = version['controls'];
        versionItem?.resValue?.disable();
        versionItem?.isNotApplicable?.disable();
        const responseArray = versionItem?.Responses;
        const assesmentArray = versionItem?.assesments;
        assesmentArray.controls.forEach((assessment) => {
          assessment['controls'].value.disable();
          assessment['controls'].isRequiredConfidential.disable();
          assessment['controls'].isPersonRequestedConfidential.disable();
          assessment['controls'].isOtherConfidential.disable();
        });
        responseArray.controls.forEach((response) => {
          response['controls'].Value.disable();
        });
      });
    });
  }

  /**
   * reset Assessment
   */
  resetAssessment() {
    this.questionForm.reset();
    this.signatureArray = [];
    this.initializeForm();
    this.populateCategories();
    this.currentCategoryIndex = 0;
    this.currentQuestionIndex = 0;
    this.showResponse = false;
    this.setInviteToCompleteValueChange(false);
  }

  // ........................End of Submit assessment.................................................//
  /**
   * show validation message
   */
  validationQuestionMessage() {
    this.toastMessage(validationMessage.assessmentQuestionValidationReq);
  }

  saveConfirmation() {
    if (this.blockOnInvalidEmail()) return;
    this.regenerateSmartlistResponses();
    if (this.checkForUnansweredQuestion()) {
      this.enableHighlight = true;
      if (!this.checkForMandatoryNotes()) {
        this.header = 'Alert!';
        this.Msg = validationMessage.notesMandatory + ' ' + this.notesMandatoryQuestions.toString() + '.';
        this.confirmationSuccessEmailComponent.openModal();
        return;
      }
      this.isFormValid = true;
      this.finalAssessmentData = this.transformAssessmentsForSaving();
      this.saveConfirmationPopup();
    }else{
      this.enableHighlight = false;
      this.validationQuestionMessage();
    }
  }

  saveConfirmationPopup() {
    if (this.isFormValid) {
      this.saveConformMessage = localStorageConstants.confirmChanges;
      this.modalEvent = {
        event: 'submitAssessment',
      };
      this.modalResponse = 'submit';
      this.message = 'Do you want to submit responses ?';
      this.btnText = 'Submit';
      this.openModal();
      // this.confirmSaveDialog.openModal();
    }
  }

  commonModalEvent() {
    if (this.modalResponse === 'submit') {
      this.submitAssessment();
    }
    if (this.modalResponse === 'caregiver') {
      this.clearCareGiverValues(this.modalEvent.index);
    }
    this.modalRef.hide();
  }

  // ............................ toggleExpansion ..........................................................//

  /**
   * toggle Expansion
   */
  toggleExpansion() {
    this.toggleExpansionFlag = !this.toggleExpansionFlag;
    this.questionCategories.controls.forEach((category) => {
      if (!this.toggleExpansionFlag) {
        this.expandmessage = localStorageConstants.expand;
        // Collapsing inner items
        category['controls']['versionItems'].controls.forEach((versionItem) => {
          versionItem['controls'].isShowCard.setValue(this.toggleExpansionFlag);
        });
        category['controls'].showCategory.setValue(this.toggleExpansionFlag);
      } else {
        this.expandmessage = localStorageConstants.collapse;
        if (
          !category['controls'].showSupportDropDown.value ||
          category['controls'].supportID.value !== null
        ) {
          category['controls'].showCategory.setValue(this.toggleExpansionFlag);
        }
      }
    });
    this.toggleClicked = true;
  }
  // ............................End of Toggle Expansion .....................................................//

  getConfidential(verionItem: any) {
    const assesmentArray = verionItem.assesments as UntypedFormArray;
    const isConfidential = assesmentArray.at(0).get('isRequiredConfidential')?.value ||
      assesmentArray.at(0).get('isPersonRequestedConfidential')?.value ||
      assesmentArray.at(0).get('isOtherConfidential')?.value;
    return isConfidential;
  }

  getTruncatedLabel(label: any) {
    if (label && label.length > 0) {
      return label.substring(0, 3);
    } else {
      return label;
    }
  }

  /**
 * @param  number i
 * @param  number j
 */
  setResponseValueFromResponseId(i, j) {
    this.setInviteToCompleteValueChange(true);
    const versionArray = this.questionCategories.at(i).get('versionItems') as UntypedFormArray;
    const assesmentArray = versionArray.at(j).get('assesments') as UntypedFormArray;
    const index = assesmentArray.getRawValue().findIndex((val) => val.assessmentID === this.assesmentNumber);
    const responseArray = versionArray.at(j).get('Responses') as UntypedFormArray;
    const responseID = assesmentArray.at(0).get('ResponseId').value;
    const responseObject = responseArray.getRawValue().find((val) => val.ResponseId === responseID);
    const assessmentValue = assesmentArray.at(0).get('value')?.value;
    if (!responseObject?.displayChildItem) {
      assesmentArray.at(index)?.get('childItemResponses')?.setValue('');
      if(this.signatureArray && this.signatureArray.length>0){
        let versionItemSignatureList :any = this.signatureArray.filter((val) => val.index === j && val.category === i  && val.isChildItem === true);
        if(versionItemSignatureList && versionItemSignatureList.length>0){
          versionItemSignatureList.forEach(element => {
        let signatureIndex = this.signatureArray.findIndex((val) => val.index === element.index && val.category === element.category && val.group === element.group && val.groupItem == element.groupItem && val.isChildItem === element.isChildItem);
        if (signatureIndex > -1) this.signatureArray.splice(signatureIndex, 1);
          });
        }
      }
    }
    versionArray.at(j).get('displayChildItem').setValue(responseObject?.displayChildItem);
    versionArray.at(j).get('displayMultiple').setValue(responseObject?.AllowMultipleGroups);
    if (versionArray.at(j).get('childItems').value.length > 0 && this.toggleClicked) {
      versionArray.at(j).get('displayChildItem').value ? versionArray.at(j).get('isShowCard').setValue(true) : versionArray.at(j).get('isShowCard').setValue(false);
    }
    if (versionArray.at(j).get('responseValueTypeID').value === this.responseDateType) {
      if (assessmentValue == 'true' || assessmentValue == 'false') {
        versionArray.at(j).get('resValue').setValue(assessmentValue);
        versionArray.at(j).get('isNotApplicable').setValue(assessmentValue);
      } else {
        versionArray.at(j).get('resValue').setValue(new Date(assessmentValue));
        versionArray.at(j).get('isNotApplicable').setValue(false);
      }
    } else {
      assesmentArray.at(0).get('value')?.setValue(responseObject?.Value);
      versionArray.at(j).get('resValue')?.setValue(responseObject?.Value);
    }
    versionArray.at(j).get('ResponseId')?.setValue(responseObject?.ResponseId);
    this.skipQuestions();
    this.setScoringLogic();
  }

  /**
    * colorPaletteWith Confidential
    * @param object assesment
    * @param boolean Confidential
    */
  colorPaletteWithIsConfidential(assesment: any, confidential: any) {
    const assessmentControl = assesment.controls.colorPalette;
    if (
      confidential &&
      assessmentControl &&
      assessmentControl.value
    ) {
      const bacgroundColor =
        'repeating-linear-gradient(135deg, ' +
        assessmentControl.value +
        ', ' +
        assessmentControl.value +
        ' 20px, #CCCCCC 20px, #cccccc 40px)';
      return bacgroundColor;
    } else if (assessmentControl && assessmentControl.value) {
      return assessmentControl.value;
    } else {
      return null;
    }
  }
  /**
  * Disable PastAndFuture Support
  */
  DisablePastAndFutureSupport() {
    if (this.personSupports?.length > 0) {
      this.personSupports?.forEach((item, i) => {
        if (!item.isCurrent) {
          this.personSupports[i].isDisable = true;
        } else if (item.isCurrent) {
          const today = moment(moment(new Date()).format('YYYY-MM-DD'));
          const startDate = moment(moment(item.startDate).format('YYYY-MM-DD'));
          const endDate = moment(moment(item.endDate).format('YYYY-MM-DD'));
          if (startDate.isAfter(today)) {
            this.personSupports[i].isDisable = true;
          } else if (
            startDate.isBefore(today) &&
            !(item.endDate === null) &&
            endDate.isBefore(today)
          ) {
            this.personSupports[i].isDisable = true;
          }
        }
      });
      this.totalActiveSupports = this.personSupports.filter(
        (val: any) => val.isDisable === false
      )?.length;
    }
  }
  /**
   * End Date Of Questionnaire Item Checking
   */
  validQuestionEndDate() {
    this.questionCategories.getRawValue().forEach((element, i) => {
      const versionArray = this.questionCategories.at(i).get('versionItems') as UntypedFormArray;
      versionArray?.getRawValue()?.forEach((versionDetail, index) => {
        this.categories.forEach((version, i) => {
          version?.VersionItems?.forEach(item => {
            if (item.ItemId === versionDetail.ItemId) {
              if (item.EndDate) {
                if (moment(moment(this.today).format('YYYY-MM-DD')).isSameOrBefore(moment(item.EndDate).format('YYYY-MM-DD'))) {
                  const assmentArray = versionArray.at(index).get('assesments') as UntypedFormArray;
                  assmentArray.getRawValue().forEach((ases, aIndex) => {
                    versionArray.at(index).get('isShowItemRow').setValue(false);
                    versionArray.at(index).get('isShowCard').setValue(true);
                    versionArray.at(index).get('endDate').setValue(moment(item.EndDate).format('MM-DD-YYYY'));
                    versionArray.at(index).get('showRadioButton').setValue(false);
                    assmentArray.at(aIndex).get('showDropDown').setValue(true);
                    assmentArray.at(aIndex).get('isSkipped').setValue(false);
                  });
                } else {
                  const assmentArray = versionArray.at(index).get('assesments') as UntypedFormArray;
                  assmentArray.getRawValue().forEach((ases, aIndex) => {
                    if ((moment(moment(ases.date).format('YYYY-MM-DD')).isSameOrBefore(moment(item.EndDate).format('YYYY-MM-DD')))) {
                      versionArray.at(index).get('isShowItemRow').setValue(false);
                      versionArray.at(index).get('isShowCard').setValue(true);
                      versionArray.at(index).get('showRadioButton').setValue(false);
                      assmentArray.at(aIndex).get('showDropDown').setValue(true);
                      versionArray.at(index).get('showDropDown').setValue(true);
                      versionArray.at(index).get('endDate').setValue(moment(item.EndDate).format('MM-DD-YYYY'));
                    } else {
                      versionArray.at(index).get('isShowItemRow').setValue(true);
                      versionArray.at(index).get('isShowCard').setValue(false);
                      assmentArray.at(aIndex).get('showDropDown').setValue(false);
                      versionArray.at(index).get('showRadioButton').setValue(true);
                      versionArray.at(index).get('endDate').setValue(moment(item.EndDate).format('MM-DD-YYYY'));
                    }
                  });
                }
              } else {
                const assmentArray = versionArray.at(index).get('assesments') as UntypedFormArray;
                assmentArray.getRawValue().forEach((ases, aIndex) => {
                  versionArray.at(index).get('endDate').setValue('No end date');
                  versionArray.at(index).get('isShowItemRow').setValue(false);
                  assmentArray.at(aIndex).get('showDropDown').setValue(true);
                  versionArray.at(index).get('showRadioButton').setValue(false);
                });
              }
            }
          });
        });
      });
    });
  }
  scrollTo(el: Element): void {
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  /**
   * Handles slider value changes for main questionnaire items
   * @param value - The new slider value (string or number)
   * @param qIndex - Question category index
   * @param vIndex - Version item index within the category
   */
  onSliderChange(value: any, qIndex: number, vIndex: number): void {
    try {
      // Convert string value to number if provided
      if (value) {
        value = Number(value);
      }
      this.setInviteToCompleteValueChange(true);
      // Get form array references
      const versionArray = this.questionCategories.at(qIndex).get('versionItems') as UntypedFormArray;
      const assesArray = versionArray.at(vIndex).get('assesments') as UntypedFormArray;
      const responseArray = versionArray.at(vIndex).get('Responses') as UntypedFormArray;

      // Find the current assessment and response configuration
      const response = responseArray.getRawValue().find((val) => val.Value !== '-');
      const maxRangeValue = responseArray.value[0]?.MaxRangeValue;
      const assessmentIndex = assesArray.getRawValue().findIndex((val) => val.assessmentID);
      const currentValue = assesArray.at(assessmentIndex).get('value').value;

      // Helper function to clear values and set to max range or default
      const clearValues = (): void => {
        setValues(maxRangeValue || '-');
      };

      // Helper function to update all related form controls with new value
      const setValues = (setValue: any): void => {
        assesArray.at(assessmentIndex).get('value').setValue(setValue);
        assesArray.at(assessmentIndex).get('ResponseId').setValue(response.ResponseId);
        versionArray.at(vIndex).get('ResponseId').setValue(response.ResponseId);
        versionArray.at(vIndex).get('resValue').setValue(setValue);
      };

      // Handle value validation and assignment
      if (!value && value !== 0) {
        // If no value provided, check if current value exceeds max range
        if (maxRangeValue && maxRangeValue < currentValue) {
          clearValues();
        } else {
          setValues(value);
        }
      } else if (maxRangeValue && maxRangeValue < value) {
        // If new value exceeds max range, reset to max range
        clearValues();
      } else {
        // Set valid value directly
        setValues(value);
      }

      // Update assessment calculations and summations
      this.findAssesmentSummation();
      this.setScoringLogic();

    } catch (error) {
      console.error('Error in onSliderChange:', error);
    }
  }

  isNaN(value: any): boolean {
    return isNaN(value);
  }

  onResponseAddressChange( qIndex, vIndex, eventValue?) {
    this.setvalueChange();
    this.setInviteToCompleteValueChange(true);
    if (this.assesmentNumber !== undefined) {
      const versionArray = this.questionCategories.at(qIndex).get('versionItems') as UntypedFormArray;
      versionArray.at(vIndex).get('resValue').setValue(eventValue?.value);
      const assesArray = versionArray.at(vIndex).get('assesments') as UntypedFormArray;
      const index = assesArray.getRawValue().findIndex((val) => val.assessmentID === this.assesmentNumber);
      assesArray.at(index).get('value').setValue(eventValue?.value);
      assesArray.at(index).get('ResponseId').setValue(0);
      this.findAssesmentSummation();
    }
  }

  textValueChange(i, j, type?) {
    const versionArray = this.questionCategories.at(i).get('versionItems') as UntypedFormArray;
    const assesArray = versionArray.at(j).get('assesments') as UntypedFormArray;
    const assessmentValue = assesArray.at(0).get('value').value;
    const responseValue = versionArray.at(j).get('resValue').value;
    const index = assesArray.getRawValue().findIndex((val) => val.assessmentID);
    const responseArray = versionArray
      .at(j)
      .get('Responses') as UntypedFormArray;
    const response = responseArray
      .getRawValue()
      .find((val) => val.Value != '-');
    if (type == 1) {
      versionArray.at(j).get('resValue').setValue(assessmentValue);
      assesArray.at(0).get('value').setValue(assessmentValue);
      assesArray.at(index).get('ResponseId').setValue(response?.ResponseId);
    } else {
      versionArray.at(j).get('resValue').setValue(responseValue);
      assesArray.at(0).get('value').setValue(responseValue);
      assesArray.at(index).get('ResponseId').setValue(response?.ResponseId);
    }
    this.findAssesmentSummation();
  }

  changeText(event, i, j) {
    const versionArray = this.questionCategories.at(i).get('versionItems') as UntypedFormArray;
    const assesArray = versionArray.at(j).get('assesments') as UntypedFormArray;
    const index = assesArray.getRawValue().findIndex((val) => val.assessmentID === this.assesmentNumber);
    let resValue = versionArray.at(j).get('resValue').value
    versionArray.at(j).get('resValue').setValue(event?.target?.value);
    assesArray.at(index).get('value').setValue(event?.target?.value);

  }

  onTextPaste(i, j, event, type?) {
    let clipboardData = event?.clipboardData;
    let pastedText = clipboardData?.getData('text');
    const versionArray = this.questionCategories?.at(i)?.get('versionItems') as UntypedFormArray;
    const assesArray = versionArray?.at(j)?.get('assesments') as UntypedFormArray;
    const index = assesArray?.getRawValue()?.findIndex((val) => val?.assessmentID === this.assesmentNumber);
    if(type === 1) {
      let value = assesArray?.at(index)?.get('value')?.value
      versionArray?.at(j)?.get('resValue').setValue(value && value!=='' ? value + pastedText : pastedText);
    }
    if(type === 2) {
      let resValue = versionArray?.at(j)?.get('resValue')?.value
      assesArray?.at(index)?.get('value').setValue(resValue && resValue !=='' ? resValue + pastedText : pastedText);
    }
  }

  textAreaClicked(catIndex:any,verIndex:any){
    this.shouldApplyMask = true;
    const versionArray = this.questionCategories.at(catIndex).get('versionItems') as UntypedFormArray;
    const assesArray = versionArray.at(verIndex).get('assesments') as UntypedFormArray;
    const index = assesArray.getRawValue().findIndex((val) => val.assessmentID);
    const currentValue = assesArray.at(index).get('value').value;
    const currentResValue = versionArray.at(verIndex).get('resValue').value;
    if (currentValue === '-') {
      assesArray.at(index).get('value').setValue(null);
    }
    if (currentResValue === '-') {
      versionArray.at(verIndex).get('resValue').setValue(null);
    }
  }

  onResponseChange(responseDate, qIndex, vIndex, eventValue?) {
    this.setInviteToCompleteValueChange(true);
    const versionArray = this.questionCategories.at(qIndex).get('versionItems') as UntypedFormArray;
    const assesArray = versionArray.at(vIndex).get('assesments') as UntypedFormArray;
    const responseArray = versionArray.at(vIndex).get('Responses') as UntypedFormArray;
    const IsResponseIdAvailable = versionArray?.at(vIndex)?.get('IsResponseIdAvailable').value;
    let response;
    if (IsResponseIdAvailable) {
      const responseID = assesArray.at(0).get('ResponseId').value;
      response = responseArray.getRawValue().find((val) => val.ResponseId === responseID);
    } else {
      const responseValue = eventValue?.value;
      response = responseArray.getRawValue().find((val) => val?.Value === responseValue);
    }

    const index = assesArray.getRawValue().findIndex((val) => val.assessmentID);
    const assessmentValue = assesArray.at(index).get('value').value;
    const responseValue = versionArray.at(vIndex).get('resValue').value;
    if (responseValue !== '' || assessmentValue !== '') {
      if (responseDate !== '') {
        assesArray.at(index).get('value').setValue(eventValue?.value);
        assesArray.at(index).get('ResponseId').setValue(response?.ResponseId);
        assesArray.at(index).get('itemResponseBehaviorID').setValue(null);
        versionArray.at(vIndex).get('resValue').setValue(eventValue?.value);
        versionArray.at(vIndex).get('ResponseId').setValue(response?.ResponseId);
      } else {
        versionArray.at(vIndex).get('resValue').setValue(eventValue?.value);
        assesArray.at(index).get('value').setValue(eventValue?.value);
        assesArray.at(index).get('ResponseId').setValue(response?.ResponseId);
        assesArray.at(index).get('itemResponseBehaviorID').setValue(null);
        versionArray.at(vIndex).get('ResponseId').setValue(response?.ResponseId);
      }
    } else {
      assesArray.at(index).get('value').setValue('-');
      assesArray.at(index).get('ResponseId').setValue(response.ResponseId);
      assesArray.at(index).get('itemResponseBehaviorID').setValue(null);
    }
    this.findAssesmentSummation();
  }

  onCheckBoxChange(value, qIndex, vIndex) {
    this.setInviteToCompleteValueChange(true);
    const versionArray = this.questionCategories.at(qIndex).get('versionItems') as UntypedFormArray;
    const assesArray = versionArray.at(vIndex).get('assesments') as UntypedFormArray;
    const responseArray = versionArray.at(vIndex).get('Responses') as UntypedFormArray;
    const response = responseArray.getRawValue().find(val => val.Value != '-');
    const index = assesArray.getRawValue().findIndex((val) => val.assessmentID);
    if (value !== undefined && index >= 0) {
      assesArray.at(index).get('value').setValue(value);
      assesArray.at(index).get('ResponseId').setValue(response.ResponseId);
      if (value === true) {
        versionArray.at(vIndex).get('resValue')?.setValue(null);
        assesArray.at(index).get('value').setValue(value);
      } else {
        assesArray.at(index).get('value').setValue(null);
      }
    }
    this.findAssesmentSummation();
  }
  setResponseIdForSignatureandDoodle(qIndex, vIndex) {
    const versionArray = this.questionCategories.at(qIndex).get('versionItems') as UntypedFormArray;
    const assesArray = versionArray.at(vIndex).get('assesments') as UntypedFormArray;
    const responseArray = versionArray.at(vIndex).get('Responses') as UntypedFormArray;
    const response = responseArray.getRawValue().find(val => val.Value != '-');
    const index = assesArray.getRawValue().findIndex((val) => val.assessmentID);
    if (index >= 0) {
      assesArray.at(index).get('ResponseId').setValue(response.ResponseId);

    }
    this.findAssesmentSummation();
    return response.ResponseId;
  }

  validateDateFormat(event, input, type?: any) {
    const keyCode = (event.which) ? event.which : event.keyCode;
    const seperator = '/';
    let isShift = false;
    if (keyCode === 16) {
      isShift = true;
    }
    if (input.value.length === 10 || (keyCode > 31 && (keyCode < 47 || keyCode > 57))) {
      return false;
    }
    return this.validateFullDate(input);
  }

  validateFullDate(input) {
    const keyUpValueCheck = /^[0-9,/]*$/;
    const dateString = input.value;
    if (keyUpValueCheck.test(dateString) === false) {
      input.value = '';
      return false;
    }
    const regex = /(((0|1)[0-9]|2[0-9]|3[0-1])\/(0[1-9]|1[0-2])\/((19|20)\d\d))$/;
    if (regex.test(dateString) || dateString.length === 0) {
      return true;
    } else if (dateString.length >= 10) {
      return false;
    }
  }

  isValidDate(event, input, type?: any) {
    type.isDateValid = false;
    const value = input.value;
    if (value && typeof value === 'string') {
      const match = value.match(/^([0-9]{1,2})\/([0-9]{1,2})\/([0-9]{4})$/);
      if (match != null) {
        const date = new Date(`${match[3]}-${match[1]}-${match[2]}`);
        const year = + match[3];
        const day = +match[2];
        const month = +match[1];
        if (isNaN(date.getTime())) {
          if (type != null) {
            type.isDateValid = true;
          }
          event.preventDefault();
          return true;
        } else {
          if ((month === 4 || month === 6 || month === 9 || month === 11) && (day >= 31)) {
            if (type != null) {
              type.isDateValid = true;
            }
          } else if (month === 2) {
            if (year % 4 !== 0) {
              if (day > 28) {
                if (type != null) {
                  type.isDateValid = true;
                }
              }
            }
            if (year % 4 === 0) {
              if (day > 29) {
                if (type != null) {
                  type.isDateValid = true;
                }
              }
            }
          }
        }
      } else {
        if (type != null) {
          type.isDateValid = true;
        }
      }
    }
  }

  getTruncatedLabelFromValue(assessmentValue: any, versionControl: any, version) {
    if (version.controls.responseValueTypeID.value === this.responseListType) {
      const label = this.getLabelFromValue(assessmentValue.controls.ResponseId.value, versionControl);
      return this.getTruncatedLabel(label);
    }
    if (version.controls.responseValueTypeID.value === this.responseSliderType) {
      return assessmentValue.controls.value.value >= 0 ? assessmentValue.controls.value.value : '-';
    }
    if (version.controls.responseValueTypeID.value === this.responseTextAreaType) {
      return assessmentValue.controls.value.value != '-' ? assessmentValue.controls.value.value : '-';
    }
    if (version.controls.responseValueTypeID.value === this.responseDateType) {
      if (assessmentValue.controls.value.value == true || assessmentValue.controls.value.value == 'true') {
        return 'N/A';
      } else if (assessmentValue.controls.value.value == false ||
        assessmentValue.controls.value.value == 'false' || assessmentValue.controls.value.value == 'null') {
        return '';
      } else if (assessmentValue.controls.value.value == '-') {
        return '-';
      } else {
        return moment(assessmentValue.controls.value.value).format('DD/MM/YYYY');
      }
    }
  }

  public showSeperator(index, total, maxLength) {
    let isShow = false;
    if (((index + 1) % total) === 0 && (index + 1) !== maxLength) {
      isShow = true;
    } else {
      isShow = false;
    }
    return isShow;
  }

  public showRemoveGroup(index, total) {
    let isShow = false;
    if (((index + 1) % total) === 0 ) { //&& index > 0 && (index + 1) / total > 1
      isShow = true;
    } else {
      isShow = false;
    }
    return isShow;
  }
  public showGroupTitle(index: number, total: number): boolean {
    return index === 0 || index % total === 0;
  }

  collapseChild(index, total, i, j) {
    let versionItem = this.questionCategories.at(i).get('versionItems') as UntypedFormArray;
    let childItems = versionItem?.at(j)?.get('childItems') as UntypedFormArray;
    for (let i = index; i < index + total; i++) {
      childItems.at(i).get('isChildCollapsed').setValue(true);
    }
  }

  expandChild(index, total, i, j) {
    let versionItem = this.questionCategories.at(i).get('versionItems') as UntypedFormArray;
    let childItems = versionItem?.at(j)?.get('childItems') as UntypedFormArray;
    for (let i = index; i < index + total; i++) {
      childItems.at(i).get('isChildCollapsed').setValue(false);
    }
  }

  childGroup(index, total, maxLength) {
    let isShow = false;
    if (index === 0 || (((index) % total) === 0 && (index) !== maxLength)) {
      isShow = true;
    } else {
      isShow = false;
    }
    return isShow;
  }

  isDisplayChild(versionChilds) {
    const isValueExist = versionChilds?.some(child => child.value.isHidden === false);
    return isValueExist;
  }

  addChild(i, j) {
    let versionItem = this.questionCategories.at(i).get('versionItems') as UntypedFormArray;
    let childItems = versionItem?.at(j)?.get('childItems') as UntypedFormArray;
    let index = childItems.getRawValue().length - 1;
    let group = childItems.getRawValue().reduce((a, b) => a.groupNo > b.groupNo ? a : b)
    for (let i = 0; i < childItems.getRawValue()[index].total; i++) {
      childItems.push(this.formBuilder.group({
        ChildItemDescription: new UntypedFormControl(childItems.at(i).get('ChildItemDescription').value),
        ChildItemID: new UntypedFormControl(childItems.at(i).get('ChildItemID').value),
        ChildItemLabel: new UntypedFormControl(childItems.at(i).get('ChildItemLabel').value),
        ChildItemTitle: new UntypedFormControl(childItems.at(i).get('ChildItemTitle').value),
        ListOrder: new UntypedFormControl(childItems.at(i).get('ListOrder').value),
        ParentItemID: new UntypedFormControl(childItems.at(i).get('ParentItemID').value),
        ResponseValueTypeID: new UntypedFormControl(childItems.at(i).get('ResponseValueTypeID').value),
        childValue: new UntypedFormControl(''),
        groupNo: new UntypedFormControl(group.groupNo + 1),
        total: new UntypedFormControl(childItems.at(i).get('total').value),
        assessmentResponseID: new UntypedFormControl(0),
        Responses: this.essentialsService.populateChildResponses(childItems.at(i).get('Responses').value),
        ResponseId: new UntypedFormControl('-'),
        MaxRangeValue: new UntypedFormControl(childItems.at(i).get('MaxRangeValue').value),
        isChildCollapsed: new UntypedFormControl(false),
        isHidden: new UntypedFormControl(childItems.at(i).get('isHidden').value),
        ReceiverItemID: new UntypedFormControl(childItems.at(i).get('ReceiverItemID').value),
        IsChildItemResponseIdAvailable: new UntypedFormControl(childItems.at(i).get('IsChildItemResponseIdAvailable').value),
        ItemFormat: new UntypedFormControl(childItems.at(i).get('ItemFormat').value),
        IsChildItemResponseRequired: new UntypedFormControl(childItems.at(i).get('IsChildItemResponseRequired').value),

      }));
    }
    this.regenerateSmartlistResponses();

  }

    regenerateSmartlistResponses() {
    this.questionCategories?.getRawValue()?.forEach((category, i) => {
      const versionItems = this.questionCategories.at(i).get('versionItems');
      versionItems?.getRawValue()?.forEach((version, vIndex) => {
        this.generateSmartListResponses(i, vIndex, version, 2);
      });
    });
  }

  removeChildGroup(qIndex, vIndex, cIndex, total) {
    const versionItem = this.questionCategories.at(qIndex).get('versionItems') as UntypedFormArray;
    const childItems = versionItem?.at(vIndex)?.get('childItems') as UntypedFormArray;
    if((cIndex + 1) / total == 1 && (cIndex + 1)==childItems.length){
          if (childItems?.length > 0) {
            childItems?.getRawValue()?.forEach((child, index) => {
                childItems?.at(index)?.get('ResponseId')?.setValue('-');
                if (child.ResponseValueTypeID === this.responseListType) {
                  childItems?.at(index)?.get('childValue')?.setValue('-');
                } else if (child.ResponseValueTypeID === this.responseTextType) {
                  childItems?.at(index)?.get('childValue')?.setValue('');
                } else if (child.ResponseValueTypeID === this.responseSliderType) {
                  childItems?.at(index)?.get('childValue')?.setValue(0);
                } else if (child.ResponseValueTypeID === this.responseTextAreaType) {
                  childItems?.at(index)?.get('childValue')?.setValue('');
                } else if (child.ResponseValueTypeID === this.responseDateType) {
                  childItems?.at(index)?.get('childValue')?.setValue(null);
                } else if (child.ResponseValueTypeID === this.responseCheckboxType) {
                  childItems?.at(index)?.get('childValue')?.setValue(false);
                } else if (child.ResponseValueTypeID === this.responseSignatureType) {
                  childItems?.at(index)?.get('childValue')?.setValue(null);
                } else if (child.ResponseValueTypeID === this.responseDoodleType) {
                  childItems?.at(index)?.get('childValue')?.setValue(null);
                } else if (child.ResponseValueTypeID === this.responseAttachmentType) {
                  childItems?.at(index)?.get('childValue')?.setValue(null);
                }
                else if (child.ResponseValueTypeID === this.responseCustomListType) {
                  childItems?.at(index)?.get('childValue')?.setValue('-');
                }
            });
          }
    }else{
      for (let index = cIndex; index > cIndex - total; index--) {
        childItems.removeAt(index);
      }
      for (let i = (cIndex+1) - total; i < childItems.length; i++) {
        const currentItem = childItems.at(i);
        const currentGno = currentItem.get('groupNo')?.value;
        if (currentGno !== undefined) {
          currentItem.patchValue({ groupNo: currentGno - 1 });
        }
      }
    }
    this.regenerateSmartlistResponses();
  }

  getChildResponses(childItems, responseID) {
    let childArray = [];
    if (childItems) {
      const groupNumbers = new Set(childItems.map((val) => val.groupNo));
      groupNumbers.forEach(gNo => {
        let childGroup = []
        childItems.forEach((element, c) => {
          if (element.groupNo === gNo) {
            let signatureImage = this.signatureArray?.find(
              (val) => val.group === gNo && val.child == c && val.childData?.ChildItemID == element.ChildItemID);

            const obj = {
              "assessmentResponseID": element.assessmentResponseID,
              "childItemID": element.ChildItemID,
              "value": (element.ResponseValueTypeID === this.responseDateType && element.childValue !== null) ?
                moment(element.childValue).format('YYYY-MM-DD HH:mm:ss.SSS').toString() :
                typeof (element.childValue) === typeof (true) ? element.childValue + "" : element.childValue + "",
              "imageValue":(element.ResponseValueTypeID === this.responseSignatureType || element.ResponseValueTypeID === this.responseDoodleType) && signatureImage ? signatureImage?.image : '',
              "ResponseId": element.ResponseId != '-' ? element.ResponseId : null,
              "ResponseValueTypeID" : element.ResponseValueTypeID,
              "AssessmentResponseFiles": element?.files
                  ? this.getAssessmentFiles(element?.files)
                  : [],
            };
            childGroup.push(obj);
          }
        });
        childArray.push(childGroup);
      });
    }
    return childArray;
  }

  public setDropDownValue(event, responseData, i, j, c) {
    this.setInviteToCompleteValueChange(true);
    if (event?.value != null) {
      const versionArray = this.questionCategories.at(i).get('versionItems') as UntypedFormArray;
      let childItems = versionArray.at(j).get('childItems') as UntypedFormArray;
      const IsChildItemResponseIdAvailable = childItems.at(c).get('IsChildItemResponseIdAvailable').value;
      if (responseData) {
        let childValue;
        if (IsChildItemResponseIdAvailable) {
          childValue = responseData.find(val => val.ResponseId === event?.value);
        } else {
          childValue = responseData.find(val => val.Value === event?.value);
        }
        let childDisplayValue = '';
        if (childValue?.Label != null && childValue?.Label != '' && childValue?.Description != null && childValue?.Description != '') {
          childDisplayValue = childValue?.Label + ' - ' + childValue?.Description;
        } else if (childValue?.Label == null || childValue?.Label == '' && childValue?.Description != null && childValue?.Description != '') {
          childDisplayValue = childValue?.Description + ' '
        } else if (childValue?.Description == null || childValue?.Description == '' && childValue?.Label != null && childValue?.Label != '') {
          childDisplayValue = childValue?.Label + ' '
        } else {
          childDisplayValue = childDisplayValue = childValue?.Label + ' - ' + childValue?.Description;
        }
        if (childValue) {
          if (IsChildItemResponseIdAvailable) {
            childItems.at(c).get('childValue').setValue(childDisplayValue);
          } else {
            childItems.at(c).get('childValue').setValue(childValue?.Value);
          }
        } else {
          childItems.at(c).get('childValue').setValue('-');
        }
      }
    }
  }
  public setAddressDropDownValue(event, i, j,  c) {
    this.setvalueChange();
    this.setInviteToCompleteValueChange(true);
    if (event?.value != null) {
      const versionArray = this.questionCategories.at(i).get('versionItems') as UntypedFormArray;
      const childItems = versionArray.at(j).get('childItems') as UntypedFormArray;
      (event?.value) ?  childItems.at(c).get('childValue').setValue(event?.value): childItems.at(c).get('childValue').setValue('-');
    }
    this.findAssesmentSummation();
  }
  public showHideNotes(notesRequired, showNotes) {
    let isShowNote = false;
    if (!notesRequired) {
      if (showNotes) {
        isShowNote = true;
      } else {
        isShowNote = false;
      }
    } else {
      isShowNote = true;
    }
    return isShowNote;
  }

  isSupportValueExist(question) {
    let flag = false;
    if (question.supportID > 0) {
      flag = question?.versionItems.some(val => (val.assesments.find(i => i.value != '-')));
    }
    return flag;
  }


  handleFileInput(files: FileList, i?, j?, child?) {
    let indexDetails = {
      child: child,
      i: i,
      j: j
    }
    const input = event.target as HTMLInputElement;
    this.fileToUpload = files.item(0);
    if (this.fileToUpload) {
      const isFileValid = this.commonService.fileSizeValidation(this.fileToUpload);
      if (!isFileValid) {
        this.fileToUpload = null;
        input.value = '';
        return;
      }
      var reader = new FileReader();
      reader.onload = this._handleReaderLoaded.bind(this, indexDetails);
      reader.readAsBinaryString(this.fileToUpload);
      this.setvalueChange();
      this.setInviteToCompleteValueChange(true);
    }
  }

  _handleReaderLoaded(indexDetails, readerEvt) {
    var binaryString = readerEvt.target.result;
    let base64textString = btoa(binaryString);
    const versionArray = this.questionCategories.at(indexDetails?.i).get('versionItems') as UntypedFormArray;
    const responseArray = versionArray.at(indexDetails.j).get('Responses') as UntypedFormArray;
    const response = responseArray.getRawValue().find((val) => val.Value != '-');
    const assesArray = versionArray.at(indexDetails.j).get('assesments') as UntypedFormArray;
    const index = assesArray.getRawValue().findIndex((val) => val.assessmentID === this.assesmentNumber);

    if (!indexDetails?.isFromChild) {
    assesArray.at(index).get('ResponseId').setValue(response?.ResponseId);
      let filesArray :any = assesArray.at(index).get('files') as UntypedFormArray;
      filesArray.push(
        this.formBuilder.group({
          Author: new UntypedFormControl(this.userName),
          fileId: new UntypedFormControl(0),
          fileURL: new UntypedFormControl(''),
          UpdateDate: new UntypedFormControl(new Date()),
          fileName: new UntypedFormControl(this.fileToUpload.name),
          byteArray: new UntypedFormControl(base64textString),
        })
      );
      this.findAssesmentSummation();
    } else {
      const childItems = versionArray.at(indexDetails?.j).get('childItems') as UntypedFormArray;
      if (childItems?.value?.length) {
        childItems.getRawValue().forEach((group, g) => {
          let childGroup = childItems.at(g) as UntypedFormArray;
          group.forEach((childItemGroup, cg) => {
            let childItem = childGroup.at(cg) as UntypedFormArray;
            childItemGroup.forEach((child, i) => {
              let childControl = childItem.at(i).get('childValue') as FormControl;
              const filesArray = childItem.at(i).get('files') as UntypedFormArray;
              filesArray.push(
                this.formBuilder.group({
                  Author: new UntypedFormControl(this.userName),
                  fileId: new UntypedFormControl(0),
                  fileURL: new UntypedFormControl(''),
                  UpdateDate: new UntypedFormControl(new Date()),
                  fileName: new UntypedFormControl(this.fileToUpload.name),
                  byteArray: new UntypedFormControl(base64textString),
                })
              );
            });
          });
        });
      }

    }
  }


   /**
   * Function to set chenge when option value is changed
   */
   setvalueChange() {
    this.qiService.setValueChange(true);
  }
  setInviteToCompleteValueChange(value:boolean) {
    this.qiService.setEmailAssessmentValueChange(value);
  }

  checkForMandatoryNotes() {
    let itemCount = 0;
    let notesCount = 0;
    this.notesMandatoryQuestions = [];
    let currentDropDown;
    const questionArray = this.questionCategories.getRawValue();
    if (questionArray.length > 0) {
      questionArray.forEach((question, qindex) => {
        if ((question?.FocusId !== 2) || (question?.FocusId === 2 ? this.isSupportValueExist(question) : true)) {
          const versionItem = question?.versionItems.filter(val => val.NotesRequired && val.isResponseRequired &&
            (val.showRadioButton === false || val.showDropDown === true));
          if (versionItem?.length > 0) {
            itemCount += versionItem?.length;
            versionItem?.forEach((item, vIndex) => {
              const assessment = item?.assesments;
              if (assessment[0]?.note.length > 0 || assessment[0]?.isSkipped) {
                notesCount++;
              } else {
                const versionIndex = question?.versionItems.findIndex(val => val.ItemId === item.ItemId);
                currentDropDown = document.getElementById(
                  'mat-select-' +
                  qindex +
                  '-' +
                  versionIndex
                );
                currentDropDown?.focus();
                if (question?.FocusId === 2) {
                  const supportById = this.personSupports.find(val => val.personSupportID === question?.supportID);
                  const supportName = supportById?.supportFirstName + ' ' + (supportById?.supportMiddleName ? supportById?.supportMiddleName + ' ' : '') + supportById?.supportLastName;
                  this.notesMandatoryQuestions.push(' ' + supportName + ' - ' + item?.Title);
                }
                else {
                  this.notesMandatoryQuestions.push(item?.Title);
                }
              }
            });
          }
        }
      });
    }
    if (itemCount === notesCount) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * Check whether any question exists without answered
   * @returns
   */

  checkForUnansweredQuestion() {
    let currentDropDown;
    let isAnswered = true;
    if (this.inCompleteItemsArray && this.inCompleteItemsArray.length > 0) {
      currentDropDown = document.getElementById(
        'signature-' +
        this.inCompleteItemsArray[0].category +
        '-' +
        this.inCompleteItemsArray[0].index
      );
      this.toastMessage('Please complete your edit!');
      currentDropDown.focus();
      this.scrollTo(currentDropDown);
      return;
    }
    this.questionCategories?.getRawValue()?.forEach((category, categoryIndex) => {
      let categoryNotConfidential = this.isExternalUser ? !(category?.isAllQuestionsConfidential && this.isExternalUser): true
      if(category?.IsCategoryExpiry==0 && categoryNotConfidential){
      const focusId = this.questionCategories?.at(categoryIndex)?.get('FocusId') as UntypedFormControl;
      const supportId = this.questionCategories?.at(categoryIndex)?.get('supportID') as UntypedFormControl;
      const versionArray = this.questionCategories?.at(categoryIndex)?.get('versionItems') as UntypedFormArray;
      versionArray?.getRawValue()?.forEach((version, varsionIndex) => {
        let itemNotConfidential =  this.isExternalUser ? !version.isShowItemRow && !(this.getConfidential(version) && this.isExternalUser) : !version.isShowItemRow
        let signatureImage = null;
        if (version?.responseValueTypeID === this.responseSignatureType || version?.responseValueTypeID === this.responseDoodleType) {
          signatureImage = this.signatureArray?.find(
            (val) => val?.index === varsionIndex && val?.category === categoryIndex && val?.image
          );
        }
        const assessmentArray = versionArray?.at(varsionIndex)?.get('assesments') as UntypedFormArray;
        const assessmentData = this.emailassessmentData?.assessment;
        const assesmentIndex = assessmentArray?.getRawValue()?.findIndex((val) => val?.assessmentID === assessmentData?.assessmentID);
        assessmentArray?.getRawValue()?.forEach((assessment) => {
          let includeSignature = version?.responseValueTypeID === this.responseSignatureType || version?.responseValueTypeID === this.responseDoodleType ?
            (signatureImage == null || signatureImage == undefined) :
            (version?.responseValueTypeID === this.responseAttachmentType ?
              !(assessment?.files && assessment?.files?.length > 0) : true);
          if (focusId?.value === 2) {
            if (supportId?.value > 0) {
              if (version?.isResponseRequired && itemNotConfidential &&((assessment?.value === '-' || assessment?.value === null || assessment?.value === undefined) && ((!signatureImage || signatureImage === null || signatureImage === undefined) && (version?.responseValueTypeID === this.responseSignatureType || version?.responseValueTypeID === this.responseDoodleType))) && isAnswered && assessment?.showDropDown === true) {
                this.currentCategoryIndex = categoryIndex;
                this.currentQuestionIndex = varsionIndex;
                isAnswered = false;
                this.questionCategories?.at(categoryIndex)?.get('showCategory')?.setValue(true);
                // this.validationQuestionMessage();
                if (version.responseValueTypeID === this.responseSignatureType || version?.responseValueTypeID === this.responseDoodleType) {
                  currentDropDown = document.getElementById(
                    'signature-' +
                    categoryIndex +
                    '-' +
                    varsionIndex
                  );
                }
                else
                  currentDropDown = document.getElementById(
                    'mat-select-' +
                    categoryIndex +
                    '-' +
                    varsionIndex
                  );
                if (currentDropDown) {
                  currentDropDown.focus();
                  this.scrollTo(currentDropDown);
                }
              }
            }
          } else {
            if (includeSignature && version?.isResponseRequired && itemNotConfidential && (assessment?.isSkipped == false) && (assessment?.value === '' || assessment?.value === '-' || assessment?.value == null || assessment?.value == undefined)) {
              this.currentCategoryIndex = categoryIndex;
              this.currentQuestionIndex = varsionIndex;
              isAnswered = false;
              this.questionCategories?.at(categoryIndex)?.get('showCategory')?.setValue(true);

              // this.validationQuestionMessage();
              if (version?.responseValueTypeID === this.responseSignatureType || version?.responseValueTypeID === this.responseDoodleType) {
                currentDropDown = document.getElementById(
                  'signature-' +
                  categoryIndex +
                  '-' +
                  varsionIndex
                );
              }
              else
                currentDropDown = document.getElementById(
                  'mat-select-' +
                  categoryIndex +
                  '-' +
                  varsionIndex
                );
              if (currentDropDown) {
                currentDropDown.focus();
                this.scrollTo(currentDropDown);
              }
            }
          }
          let assessmentControl = assessmentArray?.at(assesmentIndex)?.get('ResponseId') as FormControl;
          if (assessment?.childItemResponses != "") {
            const childItems = versionArray?.at(varsionIndex)?.get('childItems') as UntypedFormArray;
            childItems?.getRawValue()?.forEach((group, g) => {
              let childGroup = childItems?.at(g) as UntypedFormArray;
              let childSignatureImage = this.signatureArray?.find(
                (val) => val?.index === varsionIndex && val?.category === categoryIndex && val?.child === g && val?.isChildItem && val?.childData?.ChildItemID === group?.ChildItemID && val?.image
              );
              let isChildInValid = false;
              if (group?.isHidden==false && version?.displayChildItem  && (group?.childValue == "" || group?.childValue == "null" || group?.childValue == null || group?.childValue == undefined || group?.childValue == "-")) {
                if((group?.IsChildItemResponseRequired && ((group?.ResponseValueTypeID == this.responseAttachmentType || group?.ResponseValueTypeID == this.responseSignatureType || group?.ResponseValueTypeID == this.responseDoodleType )) && (childSignatureImage) )){
                  isChildInValid = false;
                }else{
                  isChildInValid = true;
                }
              }
              let childControl = childItems?.at(g)?.get('childValue') as FormControl;

              if (group?.IsChildItemResponseRequired && isChildInValid || (group?.IsChildItemResponseRequired && group?.ResponseValueTypeID == this.responseDateType && group?.childValue == "Invalid date")) {
                childControl?.setValidators([Validators.required, Validators.pattern(/[^-/]/)]);
                childControl?.updateValueAndValidity();
                childControl?.markAsDirty();
                childControl?.markAsTouched();
                childControl?.markAllAsTouched();
                childControl?.setErrors({ incorrect: true })
                isAnswered = false;
              }else{
                childControl?.setErrors(null);
              }
            });
          }
          if (includeSignature && version?.isResponseRequired && itemNotConfidential && (assessment?.isSkipped == false) && (assessment?.value === '' || assessment?.value === '-' || assessment?.value === null || assessment?.value === undefined)) {

            assessmentControl?.setValidators([Validators.required, Validators.pattern(/[^-/]/)]);
            assessmentControl?.updateValueAndValidity();
            assessmentControl?.markAsDirty();
            assessmentControl?.markAsTouched();
            assessmentControl?.markAllAsTouched();
            assessmentControl?.setErrors({ incorrect: true });
            isAnswered = false;
          } else {
            assessmentControl?.setErrors(null)
          }
        });
      });
      }
    });
    if(currentDropDown){
      currentDropDown.focus();
      this.scrollTo(currentDropDown);
    }
    return isAnswered;

  }



  getDescriptionText(value: any): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(value)
  }

  generateLink(qIndex, vIndex, ItemId) {
    const assessment = this.emailassessmentData.assessment;
    this.qService.getDocuSignLInk(this.emailassessmentData.personIndex, assessment.assessmentID, ItemId).subscribe(
      (output: any) => {
        let result = output.Data;
        let envelopeId = result?.docuSignData?.envelopeId
        if (envelopeId) {
          if (assessment.assessmentID !== undefined) {
            const versionArray = this.questionCategories.at(qIndex).get('versionItems') as UntypedFormArray;
            const assesArray = versionArray.at(vIndex).get('assesments') as UntypedFormArray;
            const responseArray = versionArray.at(vIndex).get('Responses') as UntypedFormArray;
            const response = responseArray.getRawValue().find(val => val.Value != '-');
            const index = assesArray.getRawValue().findIndex((val) => val.assessmentID === assessment.assessmentID);
            versionArray.at(vIndex).get('resValue').setValue(envelopeId);
            assesArray.at(index).get('value').setValue(envelopeId);
            assesArray.at(index).get('ResponseId').setValue(response.ResponseId);
          }
        } else {
          let accessToken = result.docuSignData.accessToken;
          let redirectLink = result.docuSignData.signLink;
          window.open(
            redirectLink,
            '_blank'
          );
        }
        this.setInviteToCompleteValueChange(true);
        let redirectLink = result.docuSignData.signLink;
        window.open(
          redirectLink,
          '_blank'
        );
      },
      (err) => {
      }
    );
  }

  viewDocument(envelopeId, qIndex, vIndex) {
    const assessment = this.emailassessmentData.assessment;
    this.qService.viewDocument(envelopeId, this.emailassessmentData.personIndex).subscribe(
      (output: any) => {
        let result = output.Data;
        let redirectLink = result.docuSignData.signLink;
        window.open(
          redirectLink,
          '_blank'
        );

        const versionArray = this.questionCategories.at(qIndex).get('versionItems') as UntypedFormArray;
        const assesArray = versionArray.at(vIndex).get('assesments') as UntypedFormArray;
        const responseArray = versionArray.at(vIndex).get('Responses') as UntypedFormArray;
        const response = responseArray.getRawValue().find(val => val.Value != '-');
        const index = assesArray.getRawValue().findIndex((val) => val.assessmentID === assessment.assessmentID);
        assesArray.at(index).get('ResponseId').setValue(response.ResponseId);
        assesArray.at(index).get('value').setValue(envelopeId);
      },
      (err) => {
      }
    );
  }

  generateLinkForChild(qIndex, vIndex, childItemId, c) {
    const assessment = this.emailassessmentData.assessment;
    this.qService.getDocuSignLInk(this.emailassessmentData.personIndex, assessment.assessmentID, childItemId).subscribe(
      (output: any) => {
        let result = output.Data;
        let envelopeId = result?.docuSignData?.envelopeId
        if (envelopeId) {
          const versionArray = this.questionCategories.at(qIndex).get('versionItems') as UntypedFormArray;
          let childItems = versionArray.at(vIndex).get('childItems') as UntypedFormArray;
          childItems.at(c).get('childValue').setValue(envelopeId);
        } else {
          let redirectLink = result.docuSignData.signLink;
          window.open(
            redirectLink,
            '_blank'
          );
        }
        this.setInviteToCompleteValueChange(true);
        let redirectLink = result.docuSignData.signLink;
        window.open(
          redirectLink,
          '_blank'
        );
      },
      (err) => {
      }
    );
  }

  viewDocumentForChild(envelopeId, qIndex, vIndex, c) {
    this.qService.viewDocument(envelopeId, this.emailassessmentData.personIndex).subscribe(
      (output: any) => {
        let result = output.Data;
        let redirectLink = result.docuSignData.signLink;
        window.open(
          redirectLink,
          '_blank'
        );
        const versionArray = this.questionCategories.at(qIndex).get('versionItems') as UntypedFormArray;
        let childItems = versionArray.at(vIndex).get('childItems') as UntypedFormArray;
        childItems.at(c).get('childValue').setValue(envelopeId);
      },
      (err) => {
      }
    );
  }
  /**
   * Handles slider value changes for child questionnaire items
   * @param event - The slider change event containing the new value
   * @param responseData - Array containing response configuration including max range
   * @param qIndex - Question category index
   * @param vIndex - Version item index
   * @param c - Child control index
   */
  onChildSliderChange(
    event: any,
    responseData: any[],
    qIndex: number,
    vIndex: number,
    c: number
  ): void {
    try {
      this.setInviteToCompleteValueChange(true);
      // Extract configuration values
      const maxRangeValue = responseData[0]?.MaxRangeValue;
      const sliderValue = event.value;

      // Get form array references for child structure
      const versionArray = this.questionCategories.at(qIndex).get('versionItems') as UntypedFormArray;
      const childItems = versionArray.at(vIndex).get('childItems') as UntypedFormArray;

      // Get current value for validation
      const currentValue = childItems.at(c).get('childValue').value;

      // Set initial value (this line seems to have a bug in original, keeping for compatibility)
      childItems.at(c).get('childValue').setValue(event);

      // Helper function to clear values and set to max range or default
      const clearValues = (): void => {
        setValues(maxRangeValue || '-');
      };

      // Helper function to update child control with new value
      const setValues = (setValue: any): void => {
        childItems.at(c).get('childValue').setValue(setValue);
      };

      // Handle value validation and assignment
      if (!sliderValue && sliderValue !== 0) {
        // If no value provided, check if current value exceeds max range
        if (maxRangeValue && maxRangeValue < currentValue) {
          clearValues();
        } else {
          setValues(currentValue);
        }
      } else if (maxRangeValue && maxRangeValue < sliderValue) {
        // If new value exceeds max range, reset to max range
        clearValues();
      } else {
        // Set valid value directly
        childItems.at(c).get('childValue').setValue(sliderValue);
      }

      // Update assessment calculations and summations
      this.findAssesmentSummation();
      this.setScoringLogic();

    } catch (error) {
      console.error('Error in onChildSliderChange:', error);
    }
  }

  filter(qIndex: any, vIndex: any, cIndex: any) {
    let childItemsLength = this.questionCategoryArray[qIndex].versionItems[vIndex].childItems?.length;
    let childIndex = cIndex % childItemsLength;
    this.originaltitles = this.questionCategoryArray[qIndex].versionItems[vIndex].childItems[childIndex].Responses;
    const versionArray = this.questionCategories.at(qIndex).get('versionItems') as UntypedFormArray;
    const childItems = versionArray.at(vIndex).get('childItems') as UntypedFormArray;
    const childresponse = childItems.at(cIndex).get('Responses') as UntypedFormArray;
    let value = this.titleFilterCtrl.value;
    if (value) {
      this.titles = this.lookupService.filterForAutoCompleteCombinedItems(this.originaltitles, value, 'Label', 'Description');
    }
    else {
      this.titles = [...this.originaltitles];
    }

    if (this.titles.length > 0) {
      childresponse.clear();
      this.titles?.forEach((element: any) => {
        childresponse.push(
          this.formBuilder.group({
            AllowMultipleGroups: new UntypedFormControl(element?.AllowMultipleGroups),
            Description: new UntypedFormControl(element?.Description),
            displayChildItem: new UntypedFormControl(element?.displayChildItem),
            KeyCodes: new UntypedFormControl(element?.KeyCodes),
            Label: new UntypedFormControl(element?.Label),
            ListOrder: new UntypedFormControl(element?.ListOrder),
            ChildItemGroupNumber: new UntypedFormControl(element?.ChildItemGroupNumber),
            ResponseId: new UntypedFormControl(element?.ResponseId),
            Value: new UntypedFormControl(element?.Value),
            dropdownChar: new UntypedFormControl(element?.dropdownChar),
            MaxRangeValue: new UntypedFormControl(element?.MaxRangeValue)
          })
        );
      });
    }
    else {
      childresponse.clear();
    }
  }

  getSmartListDetails(questionDetails) {
    let smartListItems = [];
    this.questionCategories?.value?.forEach((category, cIndex) => {
      category?.versionItems?.forEach((version, vIndex) => {
        if (questionDetails.IsChildItemReceiver && questionDetails.IsReceiver) {
          questionDetails?.childItems?.forEach(childItem => {


            if (childItem?.ParentSenderItemID == version?.ItemId) {
              let smartListItem = {
                categoryIndex: cIndex,
                versionIndex: vIndex,
                item: version
              }
              smartListItems?.push(smartListItem);
            }
          });

        } else if (!questionDetails.IsChildItemReceiver && questionDetails.IsReceiver) {
          if (questionDetails?.SenderItemID == version?.ItemId) {
            let smartListItem = {
              categoryIndex: cIndex,
              versionIndex: vIndex,
              item: version
            }
            smartListItems?.push(smartListItem);
          }
        }
      });
    });
    return smartListItems;
  }

  generateSmartListResponses(i, j, version, type) {
    let smartListItems = this.getSmartListDetails(version);
    smartListItems?.forEach(smartListItem => {
      let newResponses = [];
      let childIndex;
      smartListItem?.item?.childItems.forEach((childItem) => {
        if (type == 2) {
          version.childItems.forEach((versionChildItem, vchildIndex) => {
            if (childItem?.ReceiverItemID === versionChildItem?.ChildItemID) {
              childIndex = vchildIndex;
              newResponses.push(childItem);
            }
          });
        } else {
          if (childItem?.ReceiverItemID == version.ItemId) {
            newResponses.push(childItem);
          }
        }
      });
      let uniqueItems = newResponses.filter((value, index, self) =>
        index === self.findIndex((t) => (
          t.childValue === value?.childValue
        ))
      )
      if (type == 2) {
        let versionItem = this.questionCategories.at(i).get('versionItems') as UntypedFormArray;
        let childItems = versionItem?.at(j)?.get('childItems') as UntypedFormArray;
        let childresponse = childItems.at(childIndex).get('Responses') as UntypedFormArray;
        childresponse.clear();
        let childValue = childItems.at(childIndex).get('childValue') as UntypedFormControl;
        let isChildValueExist = uniqueItems.findIndex((item => {
          return item?.childValue == childValue?.value;
        }))

        if (isChildValueExist == -1) {
          childValue?.setValue('-');
        }
        if (uniqueItems?.length > 0) {
          uniqueItems?.forEach(unique => {
            childresponse.push(
              this.formBuilder.group({
                AllowMultipleGroups: new UntypedFormControl(false),
                Description: new UntypedFormControl(unique?.childValue),
                displayChildItem: new UntypedFormControl(null),
                KeyCodes: new UntypedFormControl(unique?.childValue?.charAt(0)?.toUpperCase()),
                Label: new UntypedFormControl(unique?.childValue),
                ListOrder: new UntypedFormControl(unique?.ListOrder),
                ChildItemGroupNumber: new UntypedFormControl(childIndex),
                ResponseId: new UntypedFormControl(unique?.ResponseId),
                Value: new UntypedFormControl(unique?.childValue),
                dropdownChar: new UntypedFormControl(null),
                MaxRangeValue: new UntypedFormControl(null),
                childValue: new UntypedFormControl(unique?.childValue)
              })
            );
          });
        }
      } else {
        if (uniqueItems?.length > 0) {
          const versionArray = this.questionCategories.at(i).get('versionItems') as UntypedFormArray;
          let responseArray = versionArray.at(j).get('Responses') as UntypedFormArray;
          //   responseArray.clear();
          uniqueItems.forEach((element, index) => {
            responseArray.push(
              this.formBuilder.group({
                Description: new UntypedFormControl(element?.ChildItemDescription),
                KeyCodes: new UntypedFormControl(element?.childValue?.charAt(0)?.toUpperCase()),
                Label: new UntypedFormControl(element?.childValue),
                ListOrder: new UntypedFormControl(element?.ListOrder),
                ResponseId: new UntypedFormControl(element.ResponseId),
                ResponseValue: new UntypedFormControl(null),
                Value: new UntypedFormControl(element?.childValue),
                dropdownChar: new UntypedFormControl(element?.dropdownChar),
                MaxRangeValue: new UntypedFormControl(element?.MaxRangeValue),
                displayChildItem: new UntypedFormControl(false),
                AllowMultipleGroups: new UntypedFormControl(false),
                colorPalette: element.colorPalette
                  ? new UntypedFormControl(element?.colorPalette)
                  : null,
                scoreDetails: element?.ScoreDetails
                  ? new UntypedFormControl(element?.ScoreDetails)
                  : null
              })
            )
          })
        }
      }
    });
  }


  clearFilterValue(qIndex: any, vIndex: any, cIndex: any) {
    this.titleFilterCtrl.valueChanges.subscribe(value => {
      if (!value) {
        this.filter(qIndex, vIndex, (cIndex));
      }
    })
  }

  getAssessmentFiles(files) {
    let fileArray = [];
    if (files) {
      files.forEach((file) => {
        let fileItem = {
          assessmentResponseAttachmentID: file?.fileId,
          fileName: file?.fileName,
          byteArrayValue: file?.byteArray,
        };
        fileArray.push(fileItem);
      });
    }
    return fileArray;
  }

  getErrorMessage(itemId) {
    return this.errorMessageList?.find(item => item.ItemId === itemId)?.ErrorMessage;
  }

  // processRuleEngine(params) {
  //   this.assessmentService.processRuleEngine(params).subscribe(
  //     (res) => {
  //       if (res.StatusCode !== 200) {
  //         this.message = res.Message;
  //       }
  //       else {
  //         this.errorMessageList = res.Data;
  //       }
  //     })
  // }
  populateFiles(files) {
    const filesArray = new UntypedFormArray([]);
    files?.forEach((element) => {
      filesArray?.push(
        this.formBuilder.group({
          Author: new UntypedFormControl(element?.Author),
          fileId: new UntypedFormControl(
            element?.AssessmentResponseAttachmentID
              ? element?.AssessmentResponseAttachmentID
              : element.fileId
          ),
          fileURL: new UntypedFormControl(
            element?.FileURL ? element?.FileURL : element?.fileURL
          ),
          UpdateDate: new UntypedFormControl(element?.UpdateDate),
          fileName: new UntypedFormControl(
            element?.FileName ? element?.FileName : element?.fileName
          ),
          byteArray: new UntypedFormControl(),
        })
      );
    });
    return filesArray;
  }
  validateResponse(i, j) {
    const versionArray = this.questionCategories.at(i).get('versionItems') as UntypedFormArray;
    const assesArray = versionArray.at(j).get('assesments') as UntypedFormArray;
    const assessmentData = this.emailassessmentData?.assessment;
    const index = assesArray?.getRawValue()?.findIndex((val) => val.assessmentID === assessmentData?.assessmentID);
    let assesment :any = assesArray.at(index);
    return !assesment.controls?.ResponseId.valid && assesment.controls?.ResponseId.hasError('incorrect')
  }

  resendLink(){
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('id')) {
      this.enableResendLink = false;
      this.decryptId = encodeURIComponent(urlParams.get('id'));
      let isConsent = encodeURIComponent(urlParams.get('isConsent'));
      let isFromAdvancedSearch = encodeURIComponent(urlParams.get('isFromAdvancedSearch'));
      const agid = urlParams.get('ag') || urlParams.get('agencyId');
      const agencyId = encodeURIComponent(agid);
      let req = {
        encryptedQueryParameter : this.decryptId,
        isConsent : isConsent?.toLowerCase() == 'true' ? true : false,
        isFromAdvancedSearch : isFromAdvancedSearch?.toLowerCase() == 'true' ? true : false,
        agencyID : Number(agencyId)
      }

      this.emailAssessment.resendLink(req).subscribe(
        (response) => {
          if (
            response &&
            response?.StatusCode === 200) {
              this.errorMessage = validationMessage.resentLink
              this.enableResendLink = false
              this.invalidStatusCode = 0
          }else{
            this.enableResendLink = true;
            this.toastMessage(response.Data?.responseStatus);
          }
        },
        (error) => {
          this.enableResendLink = true;
        }
      );
    }
  }

  public undoSelection(i, j, id) {
        this.setInviteToCompleteValueChange(true);
        const versionArray = this.questionCategories?.at(i)?.get('versionItems') as UntypedFormArray;
        const responseArray = versionArray?.at(j)?.get('Responses') as UntypedFormArray;
        const assesArray = versionArray?.at(j)?.get('assesments') as UntypedFormArray;
        const index = assesArray?.getRawValue()?.findIndex((val) => val.assessmentID === this.assesmentNumber);
        const currentAnswerId = assesArray?.at(index)?.get('ResponseId').value;
        if (currentAnswerId === id && currentAnswerId && id) {
          setTimeout(() => {
            assesArray?.at(index)?.get('ResponseId')?.setValue('-');
            const responseID = assesArray?.at(index)?.get('ResponseId').value;
            const responseObject = responseArray?.getRawValue()?.find((val) => val.ResponseId === responseID);
            versionArray?.at(j)?.get('displayChildItem')?.setValue(responseObject?.displayChildItem);
            versionArray?.at(j)?.get('ResponseId')?.setValue(responseObject?.ResponseId);
            const IsResponseIdAvailable = versionArray?.at(j)?.get('IsResponseIdAvailable')?.value;
          if(!IsResponseIdAvailable){
            versionArray.at(j).get('resValue').setValue(responseObject?.Value);
          }
            versionArray?.at(j)?.get('displayMultiple')?.setValue(responseObject?.AllowMultipleGroups);
            assesArray?.at(index)?.get('value')?.setValue(responseObject?.Value);
            assesArray?.at(index)?.get("colorPalette")?.setValue(responseObject?.colorPalette);
            if(!responseObject?.displayChildItem){
          assesArray?.at(index)?.get('childItemResponses')?.setValue('');
           if(this.signatureArray && this.signatureArray.length>0){
          let versionItemSignatureList :any = this.signatureArray.filter((val) => val.index === j && val.category === i  && val.isChildItem === true);
          if(versionItemSignatureList && versionItemSignatureList.length>0){
            versionItemSignatureList?.forEach(element => {
          let signatureIndex = this.signatureArray.findIndex((val) => val.index === element.index && val.category === element.category && val.group === element.group && val.groupItem == element.groupItem && val.isChildItem === element.isChildItem);
          if (signatureIndex > -1) this.signatureArray.splice(signatureIndex, 1);
            });
          }
          }
        }
            this.findAssesmentSummation();
            this.skipQuestions();
          }, 0);
        }
    }

     showWarningSavePromptBeforeChange(i, j, event: any, version: any,  eventFrom?: any, currentDropdown?,  ResponseId?: string,category?:any): any {
        this.childValuesForChange = {
          catIndex: i,
          versionIndex: j,
          event: event,
          QuestionnaireItemID: version?.controls?.QuestionnaireItemID?.value,
          version: version,
          eventFrom: eventFrom,
          currentDropdown: currentDropdown,
          ResponseId: ResponseId,
          prvResponseId: version?.controls?.ResponseId?.value,
          category:category,
          isSkipruleApplied: false,
        };
        if ((eventFrom === "undo_itemClick" && ResponseId === version.controls.ResponseId.value ) || eventFrom !== "undo_itemClick") {
            const eventValueMap = {
              "expanded_itemClick": event?.value,
              "undo_itemClick": ResponseId,
              "collapsed_itemClick": event?.value,
              "collapsed_keyEvent": event?.key,
            };

          let  resPonseIdValue = eventValueMap[eventFrom] ?? event.value;
          const isAnySkipAction= this.isSkipRuleApplied(version, resPonseIdValue)
          if(isAnySkipAction) {
            this.childValuesForChange.isSkipruleApplied = true;
            this.confirmChildValueDiscardMessage = localStorageConstants.confirmSkipResponseMessage;
            this.confirmBtnLabel = 'Yes';
            this.confirmCancelBtnLabel = 'No';
            this.confirmDiscard.openModal();
          }
          else{
        this.confirmChildValueDiscardMessage = localStorageConstants.confirmChildValueDiscardMessage;
        this.confirmBtnLabel = 'OK';
        this.confirmCancelBtnLabel = 'Cancel';
        const versionItem = this.questionCategories.at(i).get('versionItems') as UntypedFormArray;
        const childItems = versionItem?.at(j)?.get('childItems') as UntypedFormArray;
        const isChildHaveValue = this.checkUnsaveedChildItem(childItems?.getRawValue(),i,j);
        if (isChildHaveValue) {
          if (eventFrom === "undo_itemClick" && ResponseId === this.childValuesForChange?.prvResponseId) {
            this.confirmDiscard.openModal();
            } else if (eventFrom !== "undo_itemClick") {
            this.confirmDiscard.openModal();
           }
        } else {
          this.removeMultiplegroup_UpdateResponse();
          switch (eventFrom) {
            case "expanded_itemClick":
              this.setQsResponse(this.childValuesForChange?.event, this.childValuesForChange?.version.controls, this.childValuesForChange?.catIndex, this.childValuesForChange?.versionIndex);
              break;
            case "collapsed_itemClick":
              this.setResponseValueFromResponseId(i,j);
              this.onQsSelectChange(event, version.controls)
              break;
            case "collapsed_keyEvent":
              this.onKeyPressed(event,version.controls,category.controls,currentDropdown,i,j);
              break;
            case "undo_itemClick":
              if (ResponseId === this.childValuesForChange?.prvResponseId) {
                this.undoSelection(this.childValuesForChange?.catIndex, this.childValuesForChange?.versionIndex, this.childValuesForChange?.ResponseId)
              }
              break;
          }
        }
      }
    }
      }

      checkUnsaveedChildItem(childStaticFrom: any, categoryIndex?, versionIndex?): boolean {
        if (!childStaticFrom) return false;
        return childStaticFrom?.some((childItem, groupIdx) => {
          const value = childItem.childValue;
          const type = childItem.ResponseValueTypeID;
          if (value && !['-', 'Invalid date', '', 'null', undefined].includes(value)) return true;
          if (
            (type === this.responseSignatureType || type === this.responseDoodleType) &&
            this.signatureArray?.some(
              sig =>
                sig.index === versionIndex &&
                sig.category === categoryIndex &&
                sig.group === childItem?.groupNo &&
                sig.childData?.ChildItemID == childItem?.ChildItemID
            )
          ) {
            return true;
          }
          return false;
        });
      }


      removeMultiplegroup_UpdateResponse() {
        const versionItem = this.questionCategories.at(this.childValuesForChange?.catIndex).get('versionItems') as UntypedFormArray;
        const childItems = versionItem?.at(this.childValuesForChange?.versionIndex)?.get('childItems') as UntypedFormArray;
        if (childItems?.length > 0) {
          let total = childItems?.value[0]?.total;
            for (let i = childItems.length - 1; i >= total; i--) {
            childItems.removeAt(i);
            }
          versionItem?.getRawValue()?.forEach((version, vindex) => {
            if (version.childItems?.length > 0) {
              version.childItems.forEach((child, index) => {
                  childItems?.at(index)?.get('ResponseId')?.setValue('-');
                  const defaultValues = {
                    [this.responseListType]: '-',
                    [this.responseTextType]: '',
                    [this.responseSliderType]: 0,
                    [this.responseTextAreaType]: '',
                    [this.responseDateType]: null,
                    [this.responseCheckboxType]: false,
                    [this.responseSignatureType]: null,
                    [this.responseDoodleType]: null,
                    [this.responseAttachmentType]: null,
                    [this.responseCustomListType]: '-'
                  };
                  childItems?.at(index)?.get('childValue')?.setValue(defaultValues[child.ResponseValueTypeID]);
                  if ([this.responseSignatureType, this.responseDoodleType, this.responseAttachmentType].includes(child.ResponseValueTypeID)) {
                    childItems?.at(index)?.get('imageValue')?.setValue('');
                    const filesArray = childItems?.at(index)?.get('files') as UntypedFormArray;
                    filesArray.clear();
                    // Clear signature array entries for removed child items
                    if (child.ResponseValueTypeID === this.responseSignatureType || child.ResponseValueTypeID === this.responseDoodleType) {
                      if(this.signatureArray && this.signatureArray.length > 0){
                        this.signatureArray = this.signatureArray.filter(sig => {
                          return !(
                            sig.isChildItem === true &&
                            sig.index === this.childValuesForChange?.versionIndex &&
                            sig.category === this.childValuesForChange?.catIndex &&
                            sig.child === index &&
                            sig.childData?.ChildItemID === child.ChildItemID
                          );
                        });
                        const currentIsShowCard = versionItem?.at(vindex)?.get('isShowCard')?.value;
                        this.cdr.detectChanges();
                        // Use Promise-based approach for smooth reinitialization
                        Promise.resolve().then(() => {
                          versionItem?.at(vindex)?.get('isShowCard')?.setValue(false);
                          this.cdr.detectChanges();

                          return Promise.resolve();
                        }).then(() => {
                          versionItem?.at(vindex)?.get('isShowCard')?.setValue(currentIsShowCard);
                          this.cdr.detectChanges();
                        });
                      }
                    }
                  }

              });
            }
        });
        }
      }
      getModalEventDiscard(event:any){
        this.modalTriggerFrom=null;
        if(event?.ModalTriggerFrom==='languageChangeEmailAssessment'){
        if(event?.value ){
         this.updateLanguage();
        }else{
          this.language = this.previousLanguage;
         }
        }else{
          this.language = this.previousLanguage;
          if(event && this.childValuesForChange){
          this.removeMultiplegroup_UpdateResponse();
          if(this.childValuesForChange?.eventFrom=="expanded_itemClick"){
            this.setQsResponse(this.childValuesForChange?.event, this.childValuesForChange?.version.controls, this.childValuesForChange?.catIndex, this.childValuesForChange?.versionIndex);
          }
          else if(this.childValuesForChange?.eventFrom=="collapsed_itemClick"){
            this.setResponseValueFromResponseId(this.childValuesForChange?.catIndex, this.childValuesForChange?.versionIndex);
            this.onQsSelectChange(this.childValuesForChange?.event, this.childValuesForChange?.version.controls);
          }
          else if(this.childValuesForChange?.eventFrom=="collapsed_keyEvent"){
            this.onKeyPressed(this.childValuesForChange?.event,this.childValuesForChange?.version.controls,this.childValuesForChange?.category.controls,this.childValuesForChange?.currentDropdown,this.childValuesForChange?.catIndex, this.childValuesForChange?.versionIndex);
          }
          else if(this.childValuesForChange?.eventFrom=="undo_itemClick"){
           this.undoSelection(this.childValuesForChange?.catIndex, this.childValuesForChange?.versionIndex, this.childValuesForChange?.ResponseId)
          }
        }else{
          const versionArray = this.questionCategories.at(this.childValuesForChange?.catIndex).get('versionItems') as UntypedFormArray;
          const responseArray = versionArray.at(this.childValuesForChange?.versionIndex).get('Responses') as UntypedFormArray;
          const assesArray = versionArray.at(this.childValuesForChange?.versionIndex).get('assesments') as UntypedFormArray;
          const index = assesArray.getRawValue()?.findIndex((val) => val.assessmentID === this.assesmentNumber);
          assesArray.at(index).get('ResponseId').setValue(this.childValuesForChange?.prvResponseId);
          const responseObject = responseArray.getRawValue()?.find((val) => val.ResponseId === this.childValuesForChange?.prvResponseId);
          versionArray.at(this.childValuesForChange?.versionIndex).get('ResponseId').setValue(responseObject?.ResponseId);
        }
        }
        }
    isSkipRuleApplied(versionItem: any, ResponseId?: any): boolean {
    if (!this.hasSkipLogic || !this.skipRules?.length) return false;
    const responseArray = versionItem?.controls?.Responses?.value;
    const assessment = versionItem?.controls?.assesments?.value.find((val: any) => val.assessmentID === this.assesmentNumber);
    for (const rule of this.skipRules) {
      const conditions = rule?.questionnaireSkipLogicRuleConditions || [];
      for (const skipCondition of conditions) {
        if (versionItem?.controls?.QuestionnaireItemID?.value !== skipCondition.questionnaireItemID) {
          continue;
        }
        const listOrder = responseArray?.find((val: any) => val.ResponseId === ResponseId)?.ListOrder ?? assessment?.ResponseId;
        if (listOrder !== skipCondition?.listOrder) {
          continue;
        }
        const actions = rule?.questionnaireSkipLogicRuleActions || [];
        if (this.isSkipRuleActionTriggered(actions)) {
          return true;
        }
      }
    }
    return false;
  }

  private isSkipRuleActionTriggered(actions: any[]): boolean {
    if (!Array.isArray(actions)) {
      return false;
    }
    let isResponseHaveValue = false;
    actions.forEach(action => {
      if (isResponseHaveValue) return;
      if (action?.actionTypeName === "Category") {
        const categories = this.questionCategories?.value || [];
        const category = categories.find((cat: any) => cat.CategoryId === action?.categoryID);
        if (!category) return;
        (category?.versionItems || []).forEach(version => {
          if (isResponseHaveValue) return;
          (version?.assesments || []).forEach(assess => {
            if (isResponseHaveValue) return;
            if (
              assess.assessmentID === this.assesmentNumber &&
              (
                (assess.value !== '-' && assess.value != null && assess.value !== '') ||
                (
                  [this.responseSignatureType, this.responseDoodleType].includes(version.responseValueTypeID) &&
                  assess.value && assess.value !== '-' &&
                  assess.imageValue && assess.imageValue !== '-'
                ) ||
                ([this.responseAttachmentType].includes(version.responseValueTypeID) && assess.files && assess.files.length > 0)
              )
            ) {
              isResponseHaveValue = true;
            }
          });
        });
        return;
      }
      if (action?.actionTypeName === "Item") {
        this.questionCategories?.value?.forEach((category, qIndex) => {
          if (isResponseHaveValue) return;
          category?.versionItems?.forEach((version, vindex) => {
            if (isResponseHaveValue) return;
            const assesments = version?.assesments;
            const aIndex = assesments?.findIndex((val) => val.itemId === action.itemID && val.assessmentID === this.assesmentNumber);
            if (aIndex >= 0) {
              const assess = assesments.at(aIndex);
              if (
                (assess.value !== '-' && assess.value != null && assess.value !== '') ||
                (
                  [this.responseSignatureType, this.responseDoodleType].includes(version.responseValueTypeID) &&
                  assess.value && assess.value !== '-' &&
                  assess.imageValue && assess.imageValue !== '-'
                )
              ) {
                isResponseHaveValue = true;
              }
            }
          });
        });
        return;
      }
      else{
      // check child items
      this.questionCategories?.value?.forEach((category, qIndex) => {
        if (isResponseHaveValue) return;
        category?.versionItems?.forEach((version, vindex) => {
          if (isResponseHaveValue) return;
          const assesments = version?.assesments;
          assesments.forEach(assess => {
            if (isResponseHaveValue) return;
            if (assess.assessmentID === this.assesmentNumber && version.childItems?.length > 0) {
              version.childItems.forEach(child => {
                if (isResponseHaveValue) return;
                    if (
                      version.displayChildItem &&
                      child.childValue &&
                      !['', 'null', null, undefined, '-', 'Invalid date'].includes(child.childValue)
                    ) {
                      isResponseHaveValue = true;
                    }
                });
            }
          });
        });
      });
    }
    });

    return isResponseHaveValue;
  }
  clearchildResponse(childListGroup:any,childIndex:any,child:any) {
    const defaultValues = {
      [this.responseListType]: '-',
      [this.responseTextType]: '',
      [this.responseSliderType]: 0,
      [this.responseTextAreaType]: '',
      [this.responseDateType]: null,
      [this.responseCheckboxType]: false,
      [this.responseSignatureType]: null,
      [this.responseDoodleType]: null,
      [this.responseAttachmentType]: null,
      [this.responseCustomListType]: '-'
    };

    childListGroup?.at(childIndex)?.get('childValue')?.setValue(defaultValues[child.ResponseValueTypeID]);

    if (
      [this.responseSignatureType, this.responseDoodleType, this.responseAttachmentType]
        .includes(child.ResponseValueTypeID)
    ) {
      childListGroup?.at(childIndex)?.get('imageValue')?.setValue('');
      const filesArray = childListGroup?.at(childIndex)?.get('files') as UntypedFormArray;
      filesArray.clear();
    }
  }

  changeLanguage(value?: string) {
    if (!this.isChanged) {
      if (value) {
        this.language = value;
      }
      this.updateLanguage();
    } else {
      this.confirmChildValueDiscardMessage = localStorageConstants?.confirmDiscardChanges;
      this.confirmBtnLabel = 'OK';
      this.confirmCancelBtnLabel = 'Cancel';
      this.modalTriggerFrom = 'languageChangeEmailAssessment';
      this.confirmDiscard.openModal();
    }
  }
  updateLanguage() {
      let currentLanguage = this.languages.find((x) => x.attribute == this.language);
      this.language = currentLanguage?.attribute;
      this.previousLanguage = this.language;
      this.questionCategories?.clear();
      this.setdefaultTranslator();
      this.lookupService.setEmailLanguage(currentLanguage);
      this.questionsAndDetails = null;
      this.getQuestionsDetails();
  }
  setdefaultTranslator(){
    this.translatorService.setDefaultLang(this.language || 'en');
    this.translatorService.use(this.language || 'en');
  }

  /**
   * PCIS-10708: Apply Validators.pattern(email) to `value` (assessment-level) and
   * `resValue` (item-level) form controls where ItemFormat === 'email'.
   * Safe to run multiple times (idempotent setValidators).
   */
  applyItemFormatValidators() {
    this.questionCategories?.controls?.forEach((category) => {
      const versionItems = category?.get('versionItems') as UntypedFormArray;
      versionItems?.controls?.forEach((version) => {
        const itemFormat = version?.get('ItemFormat')?.value;
        if (itemFormat === 'email') {
          const emailValidators = [Validators.pattern(this.emailPattern)];
          const resValueCtrl = version?.get('resValue');
          if (resValueCtrl) {
            resValueCtrl.setValidators(emailValidators);
            resValueCtrl.updateValueAndValidity({ emitEvent: false });
          }
          const assessments = version?.get('assesments') as UntypedFormArray;
          assessments?.controls?.forEach((assessment) => {
            const valueCtrl = assessment?.get('value');
            if (valueCtrl) {
              valueCtrl.setValidators(emailValidators);
              valueCtrl.updateValueAndValidity({ emitEvent: false });
            }
          });
        }
      });
    });
  }

  /**
   * PCIS-10708: Returns true if the given version (item) is configured as an
   * email-format field via ItemFormat === 'email'. Used by the template to
   * show validation errors.
   */
  isEmailFormatItem(version: any): boolean {
    return version?.controls?.ItemFormat?.value === 'email';
  }

  /**
   * PCIS-10708: Walk the form and return the location of the first email-format
   * control whose value fails the email pattern, or null if everything passes.
   * Mirrors the form-walk shape of applyItemFormatValidators().
   */
  private findFirstInvalidEmailField(): {
    categoryIndex: number;
    versionIndex: number;
    controlType: 'resValue' | 'value';
    assessmentIndex?: number;
    control: AbstractControl;
  } | null {
    const categories = this.questionCategories?.controls ?? [];
    for (let c = 0; c < categories.length; c++) {
      const versions = categories[c].get('versionItems') as UntypedFormArray;
      const vCtrls = versions?.controls ?? [];
      for (let v = 0; v < vCtrls.length; v++) {
        if (vCtrls[v].get('ItemFormat')?.value !== 'email') continue;
        const resValueCtrl = vCtrls[v].get('resValue');
        if (resValueCtrl?.hasError('pattern')) {
          return { categoryIndex: c, versionIndex: v, controlType: 'resValue', control: resValueCtrl };
        }
        const assessments = vCtrls[v].get('assesments') as UntypedFormArray;
        const aCtrls = assessments?.controls ?? [];
        for (let a = 0; a < aCtrls.length; a++) {
          const valueCtrl = aCtrls[a].get('value');
          if (valueCtrl?.hasError('pattern')) {
            return { categoryIndex: c, versionIndex: v, controlType: 'value', assessmentIndex: a, control: valueCtrl };
          }
        }
      }
    }
    return null;
  }

  /**
   * PCIS-10708: Gate function used by save/submit handlers. If any email-format
   * field is invalid, mark it touched, surface a toast, scroll/focus to it,
   * and return true so callers can abort.
   */
  private blockOnInvalidEmail(): boolean {
    const invalid = this.findFirstInvalidEmailField();
    if (!invalid) return false;
    invalid.control.markAsTouched();
    invalid.control.markAsDirty();
    this.questionCategories?.at(invalid.categoryIndex)?.get('showCategory')?.setValue(true);
    this.toastMessage(this.alertMessage.emailValid);
    const elId = invalid.controlType === 'resValue'
      ? `email-input-${invalid.categoryIndex}-${invalid.versionIndex}`
      : `email-input-${invalid.categoryIndex}-${invalid.versionIndex}-${invalid.assessmentIndex}`;
    const el = document.getElementById(elId);
    if (el) { el.focus(); this.scrollTo(el); }
    return true;
  }
}
